/**
 * @license
 * @qwik.dev/core 2.0.0-beta.37-dev+c3b933c
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as Ne, isBrowser as Ce } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as Ie } from "@qwik.dev/core/preloader";

const Oe = !1;

const Le = (t, ...n) => Fe(!1, t, ...n);

const Fe = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const De = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const Xe = (t, n, e, s, o = !1) => {
    const r = De(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const We = (t, n, e) => {
    const s = De(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Ve = (t, n, e) => De(t, n, e) >= 0;

const Ue = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const ze = t => typeof t === "object" && t !== null;

const Be = t => Array.isArray(t);

const Qe = t => typeof t === "string";

const He = t => typeof t === "function";

const Je = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = Fe(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const Ye = "<sync>";

const Ge = t => typeof t === "function" && typeof t.getSymbol === "function";

const td = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const Ke = "q:type";

const Ze = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const ei = 124;

const ii = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const ri = "q:renderFn";

const si = "q:targetEl";

const oi = "⚡️";

const li = "q:slot";

const ui = "q:s";

const ci = "[q\\:patch]";

const fi = "q:r";

const nd = "q:rp";

const ai = "q:style";

const hi = "style[q\\:style]";

const di = hi + ",style[q\\:sstyle]";

const pi = "q:sstyle";

const $i = "q:ctx";

const yi = "q:brefs";

const mi = (t, n) => t["qFuncs_" + n] || [];

const wi = "q:base";

const vi = "q:container-island";

const bi = "/" + vi;

const _i = "q:ignore";

const gi = "/" + _i;

const Ei = "q:container";

const Si = "/" + Ei;

const ki = "q:cursorBoundary";

const Ri = "q:template";

const Pi = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const Ti = "http://www.w3.org/1999/xhtml";

const qi = "http://www.w3.org/2000/svg";

const Ai = "http://www.w3.org/1998/Math/MathML";

const Mi = "qRender";

const xi = "q:id";

const Ii = "q:key";

const Ni = "q:props";

const Ci = "q:seq";

const Oi = "q:seqIdx";

const ji = "q:p";

const Li = "q:ps";

const Di = ":on";

const Xi = ":onIdx";

const Wi = ":onFlags";

const Vi = ":nearestCursorBoundary";

const Ui = ":";

const zi = "dangerouslySetInnerHTML";

const Qi = 100;

const Hi = t => !!t && typeof t == "object" && typeof t.then === "function";

const Ji = (t, n, e) => {
    try {
        const s = t();
        return Hi(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const Yi = (t, n) => Hi(t) ? t.then(n) : n(t);

const Gi = t => new Promise(n => {
    setTimeout(n, t);
});

const Ki = t => {
    throw t;
};

function n(t, n = Ki) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!Hi(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = Qi;
    const r = async e => {
        for (;Hi(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!Hi(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const Zi = t => oi + t;

const tr = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + Zi(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const nr = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + er(t.slice(s, -1));
        }
    }
    return null;
}

const er = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = ir(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const ir = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const rr = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const sr = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const or = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const lr = t => {
    if (!t) {
        return "";
    }
    if (Qe(t)) {
        return t.trim();
    }
    const n = [];
    if (Be(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = lr(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const ur = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const cr = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (Be(t)) {
            throw Je(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(ur(e) + ":" + fr(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

function i(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = lr(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = cr(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const fr = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => sr.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const ar = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        let s = !0;
        e.port1.onmessage = () => t();
        n = () => {
            s && e.port2.postMessage(null);
        };
        n.ln = () => {
            if (s) {
                s = !1;
                e.port1.onmessage = null;
                e.port1.close();
                e.port2.close();
            }
        };
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const hr = () => ({
    isServer: Ne,
    importSymbol(t, n, e) {
        if (Ne) {
            const t = td(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw Je(6, [ e ]);
        }
        if (!n) {
            throw Je(14, [ e ]);
        }
        if (!t) {
            throw Je(13, [ n, e ]);
        }
        const s = dr(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const dr = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(wi) ?? s, s);
    return new URL(e, o);
};

let pr = /*#__PURE__ */ hr();

const $r = t => pr = t;

const yr = () => pr;

const ed = () => pr.isServer;

const sd = typeof document !== "undefined";

const mr = !Ne && sd;

const wr = mr ? document : void 0;

const vr = mr && wr.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

const br = /\.[mc]?js$/;

const _r = t => {
    let n = gr.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            un: t,
            Vt: br.test(t) ? 0 : 3,
            cn: n,
            fn: 1,
            an: performance.now(),
            hn: 0,
            dn: 0
        }))(t, e);
        gr.set(t, n);
    }
    return n;
};

const gr = new Map;

let Er = 0;

const Sr = [];

const kr = ar(function od() {
    Pr = !1;
    if (!Sr.length) {
        return;
    }
    const t = performance.now() + 10;
    let n = !1;
    for (;Sr.length; ) {
        const e = Sr[0];
        const s = e.fn;
        const o = 1 - s;
        if (!(o >= .99 || Er < 25)) {
            break;
        }
        Sr.shift();
        xr(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && Sr.length && !Pr) {
        Pr = !0;
        kr();
    }
});

const Rr = ar(r);

let Pr = !1;

let Tr = !1;

let qr = !1;

const Ar = [];

const Mr = () => {
    const t = Ar[Ar.length - 1];
    const n = t.pn;
    if (t.cn) {
        const e = t.It;
        if (e >= t.cn.length) {
            Ar.pop();
            return !1;
        }
        const s = t.cn[e];
        t.It = e + 1;
        const o = _r(s.un);
        if (o.fn === 0) {
            return !0;
        }
        const r = 1 - n.fn;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s.$n);
        } else {
            const t = 1 - s.$n * r;
            const n = s.yn;
            const e = t / n;
            i = Math.max(.02, o.fn * e);
            s.yn = e;
        }
        Ar.push({
            pn: o,
            fn: i,
            mn: t.mn
        });
        return !0;
    }
    if (t.mn?.has(n)) {
        Ar.pop();
        return !1;
    }
    const e = n.fn;
    n.fn = t.fn;
    if (e - n.fn < .01) {
        Ar.pop();
        return !1;
    }
    if (n.cn?.length) {
        const e = t.mn || new Set;
        e.add(n);
        t.mn = e;
        t.cn = n.cn;
        t.It = 0;
        return !1;
    }
    Ar.pop();
    return !1;
};

function r() {
    if (qr || !Ar.length) {
        return;
    }
    Tr = !1;
    qr = !0;
    const t = mr ? performance.now() + 10 : 0;
    let n = !1;
    for (;Ar.length; ) {
        n = !0;
        const e = Mr();
        if (mr && e && performance.now() >= t) {
            if (!Tr) {
                Tr = !0;
                Rr();
            }
            break;
        }
    }
    qr = !1;
    n && mr && kr();
}

const xr = t => {
    if (t.Vt >= 2) {
        return;
    }
    Er++;
    const n = performance.now();
    t.hn = n - t.an;
    t.Vt = 2;
    const e = wr.createElement("link");
    e.href = new URL("undefined" + t.un, wr.baseURI).toString();
    e.rel = vr;
    e.as = "script";
    e.onload = e.onerror = () => {
        Er--;
        const s = performance.now();
        t.dn = s - n;
        t.Vt = 4;
        e.remove();
        kr();
    };
    wr.head.appendChild(e);
};

const Ir = (t, n) => {
    const e = _r(t);
    e && ((t, n) => {
        Ar.unshift({
            pn: t,
            fn: n,
            mn: void 0
        });
    })(e, n);
};

mr && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    Ir(e, 0);
                }
            } else {
                Ir(t, 0);
            }
            mr ? Rr() : r();
        })(t);
    }
});

const Nr = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const Cr = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    },
    writeRootRefDelta(t, n) {
        return ((t, n, e) => t.write(n - e + ""))(this, t, n);
    }
});

const Or = '"';

const jr = "[";

const Lr = "]";

const Fr = ",";

const Dr = "2.0.0-beta.37-dev+c3b933c";

const Xr = t => t.nodeType === 1;

const rd = t => t.Un;

const Wr = Symbol();

class Vr {
    [Wr]=void 0;
}

const Ur = t => t === "foreignObject";

const zr = t => t === "svg" || Ur(t);

const Br = t => t === "math";

function s(t, n, e, o = !1) {
    const r = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== Ui && r.setAttribute(e.name, e.value);
    }
    if (o) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const i = t.childNodes[n];
            const c = i.nodeType;
            c === 3 ? r.appendChild(i.cloneNode()) : c === 1 && r.appendChild(s(i, i.localName, e, o));
        }
    }
    return r;
}

const Qr = {
    elementNamespace: Ti,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!Bl(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && Ur(Bl(t));
    let o = Ti;
    let r = 0;
    const i = typeof n === "string" || pl(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return zr(t);
        }
        if (pl(t)) {
            return zr(Bl(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = qi;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return Br(t);
        }
        if (pl(t)) {
            return Br(Bl(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Ai;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? qi : e ? Ai : Ti;
        r = t.flags & 1536;
    }
    Qr.elementNamespace = o;
    Qr.elementNamespaceFlag = r;
    return Qr;
}

class Hr {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [Wr]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class Jr extends Hr {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class Yr extends Jr {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class Gr extends Hr {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const Kr = [];

const Zr = [];

function l(t, n) {
    const e = y(n).priority;
    let s = Kr.length;
    for (let t = 0; t < Kr.length; t++) {
        const n = y(Kr[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Kr.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < Kr.length; t++) {
        const n = Kr[t];
        let e = !1;
        for (let t = 0; t < Zr.length; t++) {
            const s = Zr[t];
            if (pu(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    Zr.push(t);
    h(t, n, !0);
    n.o++;
}

function f(t, n) {
    d(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    l(n, t);
}

function a(t, n, e) {
    const s = y(e);
    if (!s || s === n) {
        return;
    }
    h(e, t, !1);
    d(e, t);
    $(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function h(t, n, e) {
    e || (t.flags &= -257);
    const s = Kr.indexOf(t);
    if (s !== -1) {
        Kr.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function d(t, n) {
    const e = Zr.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = Zr.length - 1;
    e !== s && (Zr[e] = Zr[s]);
    Zr.pop();
    n.o--;
    return !0;
}

const ts = new WeakMap;

const ns = ":nodeProps";

const es = ":nodeDiff";

const is = ":errorData";

const rs = ":signal";

const ss = ":inlineComponentData";

function p(t, n, e) {
    n.position = e;
    e && dn(e) && function s(t, n, e) {
        const s = y(e);
        if (!s || s === n) {
            return;
        }
        h(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            $(t, n);
        })(n, s);
    }(t, n, e);
}

function $(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function y(t) {
    return ts.get(t) ?? null;
}

const os = Symbol();

class ls {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const us = Symbol();

const cs = Symbol();

const fs = Symbol();

function m(t, n, e) {
    t[Wr] || (Ne && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(yi, new Map) : t[Wr] = new Map);
    const o = t[Wr];
    let r = o.get(n);
    if (!r) {
        r = new ls(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const as = (t, n) => (e, s) => {
    const o = Me();
    o.en = m(t, ":");
    o.$ = n || void 0;
    return Te(o, () => {
        if (He(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (Tu(e)) {
            return e.value;
        }
        if (ze(e) && Uu(e)) {
            In(Du(e), fs, Fu(e), o.en);
            return e;
        }
        throw Je(2);
    });
};

class hs {
    Nt;
    ct=void 0;
    $=null;
    wn=null;
    constructor(t, n) {
        this.$ = t || qf()?.$ || null;
        this.Nt = n;
    }
    trigger() {
        Iu(this.$, this, this.ct);
    }
    force() {
        Iu(this.$, this, this.ct);
    }
    get untrackedValue() {
        return this.Nt;
    }
    set untrackedValue(t) {
        this.Nt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = qf();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.en;
        if (e) {
            const t = Ne;
            const s = this.ct ||= new Set;
            const o = __EXPERIMENTAL__.suspense && t;
            qu(s, e);
            Au(e, this);
            if (t) {
                const t = xu(n.$, this.$);
                o && t?.vn?.(this, e, null);
                Mu(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.Nt) {
            this.Nt = t;
            Iu(this.$, this, this.ct);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Nt
        };
    }
}

class ds extends hs {
    Ct;
    h;
    [Wr]=void 0;
    constructor(t, n, e = 17) {
        super(t || qf()?.$, os);
        this.Ct = n;
        this.h = e;
    }
    invalidate() {
        this.h |= 1;
        const t = Me();
        t.$ = this.$ || void 0;
        const e = n(qe.bind(this, t, this.p));
        e && e.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get untrackedValue() {
        this.p();
        return this.Nt;
    }
    set untrackedValue(t) {
        this.Nt = t;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = this.Ct;
        Pu(t);
        const n = qf();
        const e = n?.en;
        if (n) {
            const t = m(this, ".");
            Rn(this.$, t);
            n.en = t;
        }
        try {
            const e = t.getFn(n)();
            if (Hi(e)) {
                throw Je(29, [ t.dev ? t.dev.file : "", t.st ]);
            }
            this.h &= -2;
            super.value = e;
        } finally {
            n && (n.en = e);
        }
    }
}

class ps {
    bn;
    _n=null;
    gn=!1;
    En=!0;
    constructor(t, n, e) {
        this.bn = t;
        if (n !== void 0) {
            this.info = n;
            this.Sn = e;
        }
    }
    get track() {
        return this.kn ||= as(this.bn, this.bn.$);
    }
    get abortSignal() {
        return (this.Rn ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.bn.Nt;
        if (t !== os) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.Pn ||= []).push(t);
    }
}

class $s extends ds {
    jt=!1;
    Ot=void 0;
    Tn=null;
    [Wr]=void 0;
    constructor(t, n, e = 17, s) {
        super(t, n, e);
        if (!s) {
            return;
        }
        const o = s.initial;
        if (o !== void 0) {
            const t = typeof o === "function" ? o() : o;
            this.Nt = t;
        }
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.Lt = r;
            this.Ft = [];
        }
        const i = s.timeout;
        i && (this.Dt = i);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 64);
        s.allowStale === !1 && (this.h |= 128);
        const c = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        c && (this.expires = c);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    get untrackedValue() {
        this.p();
        if (this.Tn?._n) {
            if (this.Nt === os || Ne) {
                throw this.Tn?._n;
            }
            return this.Nt;
        }
        if (this.Ot) {
            throw this.Ot;
        }
        if (Ne && this.h & 64 && this.Nt === os) {
            throw Je(35);
        }
        return this.Nt;
    }
    set untrackedValue(t) {
        this.Nt = t;
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedLoading = !1;
        this.untrackedError = void 0;
        this.qn = void 0;
        if (this.Ft) {
            for (let t = 0; t < this.Ft.length; t++) {
                this.Ft[t].En = !1;
            }
        } else {
            this.Tn && (this.Tn.En = !1);
        }
        this.An();
        super.value = t;
        this.Mn();
    }
    get loading() {
        const t = this.untrackedLoading;
        const n = qf();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.en;
            if (t) {
                qu(this.$t ||= new Set, t);
                Au(t, this);
                Mu(t, this.$);
            }
        }
        return t;
    }
    set untrackedLoading(t) {
        if (t !== this.jt) {
            this.jt = t;
            Iu(this.$, this, this.$t);
        }
    }
    get untrackedLoading() {
        this.p();
        if (Ne && this.Tn?._n) {
            throw this.Tn?._n;
        }
        return this.jt;
    }
    get error() {
        const t = this.untrackedError;
        const n = qf();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.en;
            if (t) {
                qu(this.yt ||= new Set, t);
                Au(t, this);
                Mu(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.Ot) {
            this.Ot = t;
            Iu(this.$, this, this.yt);
        }
    }
    get untrackedError() {
        return this.Ot;
    }
    get expires() {
        return this.Pt || 0;
    }
    set expires(t) {
        this.An();
        this.Pt = t;
        this.Pt && this.xn() && this.Mn();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.Pt && this.xn()) {
            this.An();
            this.Mn();
        }
    }
    get interval() {
        const t = this.Pt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    async invalidate(t) {
        if (arguments.length > 0) {
            this.qn = t;
            this.Sn = this.Sn === void 0 ? 1 : this.Sn + 1;
        }
        this.In(!0, this.h & 128);
    }
    In(t, n) {
        this.h |= 1;
        this.An();
        n && (this.Nt = os);
        t && (this.ct?.size || this.$t?.size || this.yt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.Tn && this.Nn(this.Tn, t);
    }
    wt() {
        if (!(this.h & 32) || this.xn()) {
            return;
        }
        if (!Ce) {
            return;
        }
        setTimeout(() => {
            this.xn() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.Tn?._n; ) {
            await (this.Tn?._n);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if (Ne && this.h & 64) {
            this.jt = !0;
            this.$?.serializationCtx.Tt.add(this);
            return;
        }
        this.An();
        this.h &= -2;
        const t = this.Tn;
        t && this.Nn(t);
        const n = this.Lt === 0 ? Infinity : this.Lt ?? 1;
        if (this.Ft ? this.Ft.length >= n : t?._n) {
            this.h |= 1;
            return;
        }
        const e = this.Sn;
        const s = new ps(this, this.qn, e);
        this.Tn = s;
        this.Ft && this.Ft.push(s);
        s._n = this.Cn(s);
    }
    async Cn(t) {
        let e = this.Ct.resolved;
        if (!e) {
            this.untrackedLoading = !0;
            e = await this.Ct.resolve();
            if (t.Rn?.signal.aborted) {
                t._n = null;
                return;
            }
        }
        try {
            this.Dt && (this.On = setTimeout(() => {
                const n = Error(`timeout ${this.Dt}ms`);
                this.jn(t, n);
                t.Rn?.abort(n);
            }, this.Dt));
            const s = n(e.bind(null, t));
            let o;
            if (Hi(s)) {
                this.untrackedLoading = !0;
                o = await s;
            } else {
                o = s;
            }
            t._n = null;
            if (t.En) {
                const n = this.Ft;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].En = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = o;
            }
        } catch (n) {
            t._n = null;
            this.jn(t, n);
        }
        if ((() => t === this.Tn)()) {
            clearTimeout(this.On);
            t.Sn === this.Sn && (this.qn = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedLoading = !1;
                this.Mn();
            }
        }
    }
    jn(t, n) {
        if (t !== this.Tn || !t.En) {
            return;
        }
        t.En = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = os;
    }
    async ln() {
        this.An();
        clearTimeout(this.On);
        const t = this.Tn;
        t && this.Nn(t);
        this.Ft ? await Promise.all(this.Ft.map(t => t._n)) : await (t?._n);
    }
    An() {
        if (this.Ln !== void 0) {
            clearTimeout(this.Ln);
            this.Ln = void 0;
        }
    }
    Mn() {
        if (Ne || !this.Pt) {
            return;
        }
        this.An();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.Ln = setTimeout(() => this.In(t, n), this.Pt);
        this.Ln?.unref?.();
    }
    xn() {
        return !!(this.ct?.size || this.$t?.size || this.yt?.size);
    }
    Nn(t, n) {
        if (t.gn) {
            return;
        }
        t.gn = !0;
        t.Rn?.abort(n);
        t._n = Yi(t._n, () => this.Fn(t));
    }
    Fn(t) {
        const n = t.Pn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        const s = () => {
            t._n = null;
            n && (n.length = 0);
            const e = this.Ft;
            if (e) {
                const n = e.indexOf(t);
                n !== -1 && e.splice(n, 1);
            }
            this.p();
        };
        let o;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const s = n[t]();
                    Hi(s) && (o = (o ? o.then(() => s) : s).catch(e));
                } catch (t) {
                    e(t);
                }
            }
        }
        if (o) {
            return o.then(s);
        }
        s();
    }
}

const ys = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const ms = Symbol();

const ws = Symbol();

const vs = Symbol();

const bs = Symbol();

const _s = Symbol();

const gs = Symbol();

const Es = [];

const Ss = {};

Object.freeze(Es);

Object.freeze(Ss);

function w(t) {
    return new Proxy({}, new ks(t));
}

class ks {
    owner;
    ct=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === ms) {
            return this.owner.constProps;
        }
        if (n === ws) {
            return this.owner.varProps;
        }
        if (n === vs) {
            return this.owner;
        }
        if (n === bs) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = Ts(this.owner, n);
            n in this.owner.varProps && Rs(this, n);
        }
        return s instanceof Hs ? s.value : s;
    }
    set(t, n, s) {
        if (n === vs) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === ms) {
            this.owner.constProps = s;
        } else if (n === ws) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === Ss ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                Ps(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && Ps(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === ms || n === ws) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && Rs(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const Rs = (t, n) => {
    const e = qf();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.en;
    s && In(t.owner._proxy, n, t, s);
};

const Ps = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ct, n);
    e && Iu(t.$, t, e);
    return !!e;
};

const Ts = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const qs = (t, n) => As(t)?.[n] || Ms(t)?.[n] || null;

const As = t => {
    if (!t) {
        return null;
    }
    return ws in t ? "children" in t ? {
        ...t[ws],
        children: t.children
    } : t[ws] : t;
};

const Ms = t => {
    if (!t) {
        return null;
    }
    return ms in t ? t[ms] : null;
};

const xs = t => t && ws in t;

const Is = t => (n, ...e) => t.call(null, fa(n), ...e);

class Ns extends ds {
    constructor(t, n) {
        super(t, n, 17);
    }
    Dn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        Pu(this.Ct);
        const t = If(this.Ct.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Nt === os ? e : this.Nt;
        const r = Cf(() => this.Dn ? s?.(o) || o : n(o), this, ".", this.$);
        this.Dn = !0;
        this.h &= -2;
        const i = this.Dn && r !== "undefined" || r !== this.Nt;
        if (i) {
            this.Nt = r;
            Iu(this.$, this, this.ct);
        }
    }
}

const Cs = (t, n) => new ds(n?.container || null, t, Cu(n?.serializationStrategy || "always"));

const Os = (t, n) => new $s(n?.container || null, t, Cu(n?.serializationStrategy || "always"), n);

const js = t => new Ns(null, t);

const Ls = t => new hs(null, t);

const Fs = /*#__PURE__*/ Is(Cs);

const Ds = /*#__PURE__*/ Is(Os);

const Xs = Is(js);

const Ws = t => t.value;

const Vs = (t, n) => t[n];

const Us = t => {
    if (t.length === 1) {
        if (Tu(t[0])) {
            return t[0].wn ||= new Hs(null, Ws, t, null);
        }
        if (Uu(t[0])) {
            return new Hs(null, Ws, t, null);
        }
        return t[0].value;
    }
    return new Hs(null, Vs, t, null);
};

const zs = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!ze(n)) {
        return n[e];
    }
    if (Tu(n)) {
        if (n instanceof Hs) {
            return n;
        }
        return Us(t);
    }
    if (xs(n)) {
        const s = n[ms];
        const o = n[ws];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return Bs(n, t);
        }
    } else {
        const s = Du(n);
        if (s) {
            const n = s[e];
            return Bs(n, t);
        }
    }
    return n[e];
};

const Bs = (t, n) => Tu(t) ? t : Us(n);

const Qs = (t, n) => {
    const e = zs(t, n);
    if (e === _s) {
        return t[n];
    }
    return e;
};

class Hs extends hs {
    lt;
    ot;
    kt;
    h;
    m=void 0;
    [Wr]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, os);
        this.lt = e;
        this.ot = n;
        this.kt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this.m) {
                this.$.setHostProp(this.m, rs, this);
                yn(this.$, this.m, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            Iu(this.$, this, this.ct);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Nt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = Cf(() => this.ot(...this.lt), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Nt;
        if (n) {
            this.h |= 2;
            this.Nt = t;
        }
    }
    rt() {
        return this.ot === Ws && Tu(this.lt[0]) ? this.lt[0] : this;
    }
    set value(t) {
        throw Je(31);
    }
    get value() {
        return super.value;
    }
}

class Js {
    data;
    constructor(t) {
        this.data = t;
    }
}

Object.prototype.hasOwnProperty;

class Ys {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || Nr(n) ? Ss : n;
        this.constProps = !e || Nr(e) ? null : e;
    }
    get props() {
        return this._proxy ||= w(this);
    }
}

const Gs = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const Ks = t => t instanceof Ys;

const Zs = (t, n, e) => {
    if (typeof t === "string") {
        const s = ge(n);
        return kf(s, () => {
            Gf(Kf(s, t));
            return e();
        });
    }
    return e();
};

function v(t, n) {
    return Zs(this, n, () => {
        const t = Yf[0];
        t.value = n.type === "number" ? n.valueAsNumber : n.value;
    });
}

function b(t, n) {
    return Zs(this, n, () => {
        const t = Yf[0];
        t.value = n.checked;
    });
}

function _(t, n) {
    return Zs(this, n, () => {
        if (Yf) {
            for (let t = 0; t < Yf.length; t++) {
                const n = Yf[t];
                n instanceof $s && n.h & 64 && n.p();
            }
        }
    });
}

const to = "bind:value";

const no = "bind:checked";

const eo = "passive:";

const io = "preventdefault:";

const ro = Object.prototype.hasOwnProperty;

const so = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(er(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const oo = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return er(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return er(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return er(t.slice(11, -1));
    }
    return null;
};

const lo = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = oo(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const uo = (t, n, e, s, o, r, i) => new Ys(t, n, e, s, o, r, !1, i);

const co = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(eo)) {
                    r.push(o);
                    t.add(er(o.slice(8)));
                } else {
                    o.startsWith(io) ? h.push(o) : oo(o) !== null ? s.push(o) : o === no ? a = e[o] : o === to && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(eo)) {
                    i.push(s);
                    t.add(er(s.slice(8)));
                } else {
                    s.startsWith(io) ? d.push(s) : oo(s) !== null ? o.push(s) : s === no ? a = n[s] : s === to && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = so(e, r, h, t, l);
            l = l || e !== n;
            e = lo(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = so(n, i, d, t, u);
            u = u || n !== e;
            n = lo(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && ro.call(n, no) && delete n[no];
                if (e && ro.call(e, no)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[no];
                }
                n.checked = a;
                const t = ea(null, "_chk", b, null, [ a ]);
                if (e && ro.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Gs(n, "q-e:input", t) || c;
                }
                c = Gs(n, "q-e:input", t) || c;
            } else if (f) {
                n && ro.call(n, to) && delete n[to];
                if (e && ro.call(e, to)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[to];
                }
                n.value = f;
                const t = ea(null, "_val", v, null, [ f ]);
                if (e && ro.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Gs(n, "q-e:input", t) || c;
                }
                c = Gs(n, "q-e:input", t) || c;
            }
        }
        if (n && ro.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && ro.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new Ys(t, n, e, s, o, r, c || !0, i);
};

const fo = (t, n, e, s) => $o(t, n, s);

const ao = (t, n, e, s, o) => $o(t, {
    ...e,
    ...n
}, o);

const ho = (t, n, e, s, o, r) => $o(t, {
    ...e,
    ...n,
    children: s
}, r);

const po = t => t.children;

const $o = (t, n, e, s, o) => co(t, n, null, null, 0, e, o);

const yo = $o;

const mo = $o;

function g(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return co(t, n, null, s.children, 0, o);
}

const wo = t => t.children;

const vo = (t, n) => new Ys(po, null, null, t.children, 0, n);

const bo = t => uo(po, null, {
    [ui]: ""
}, t.children, 0, t.name ?? "");

const _o = Symbol();

const go = () => null;

const Eo = () => null;

const So = t => t.children;

const ko = (t, n) => $o(vo, {
    children: $o(Ro, t)
}, n);

const Ro = () => null;

let Po = null;

let To = null;

function E(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    To || (To = t.setAttributeNS);
                    To.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            Po || (Po = t.setAttribute);
            Po.call(t, n, e);
        })(t, n, e);
    }
}

const qo = Object.prototype.hasOwnProperty;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const Ao = (t, n = [], e = {}) => {
    let s = null;
    const o = t[ms];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[ws];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return w(new Ys(null, r, s, null, 0, null));
};

function k(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && qo.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof Hs) {
            return Of(n, t, ":", e);
        }
    }
    return Ts(n, "name") || "";
}

class Mo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class xo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Io {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class No {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class Co {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const Oo = t => new Mo(t);

const jo = t => new xo(t);

const Lo = (t, n) => new Io(t, n);

const Fo = (t, n, e) => new No(t, n, e);

const Do = (t, n, e, s = null, o = !1) => new Co(t, n, e, s, o);

const Xo = () => {
    const t = Mf();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, Ci);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, Ci, s);
    }
    let o = t.$.getHostProp(e, Oi);
    o === null && (o = 0);
    t.$.setHostProp(e, Oi, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const Wo = t => {
    const n = He(t) && !ya(t) ? Te(void 0, t) : t;
    return Ls(n);
};

const Vo = t => Uo(Wo, t);

const Uo = (t, ...n) => {
    const {val: e, set: s} = Xo();
    if (e != null) {
        return e;
    }
    t = He(t) && !ya(t) ? If(t, ...n) : t;
    return s(t);
};

const zo = () => ({
    pending: Ls(0),
    version: Ls(0)
});

function R(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = q(t.container, n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.pending.value++;
    }
}

function P(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return t.getHostProp(n, ki);
}

function T(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    _l(t, Vi, null);
}

function q(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return function e(t) {
        if (!__EXPERIMENTAL__.suspense) {
            return null;
        }
        return bl(t, Vi, null) || null;
    }(n) || P(t, n);
}

function A(t, n) {
    __EXPERIMENTAL__.suspense && _l(t, Vi, n);
}

function M(t, n, e) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    A(n, e);
    const s = n.dirtyChildren;
    if (!s || s.length === 0) {
        return;
    }
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        M(t, o, P(t, o) || e);
    }
}

const Bo = t => {
    if (t.ln) {
        try {
            t.ln();
        } catch (t) {
            Le(t);
        }
        t.ln = null;
    }
};

function x(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    if (!o) {
        const n = ge(s);
        return kf(n, () => x(t, e, s, xf(e, s, n)));
    }
    const r = o.$;
    const i = o.m;
    Sl(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r._ : null;
        const l = bl(i, ji, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = bl(i, Li, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return qe(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i));
}

function I(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = ge(n);
    return kf(e, () => {
        const s = xf(t, n, e);
        typeof this === "string" && Gf(Kf(s.$, this));
        const o = Yf[0];
        return x(o, t, n, s);
    });
}

function N(t) {
    return t.k === t.R ? t.T : null;
}

function C(t) {
    return t.q || N(t);
}

function O(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = N(t);
    return e === o ? null : e;
}

const Qo = Object.prototype.hasOwnProperty;

function j(t, n, e, s, o, r) {
    _l(n, e, r);
    mn(t, Do(n.node, e, s, o, (n.flags & 512) !== 0));
}

function L(t, n, e, s) {
    return {
        $: t,
        M: n,
        N: e,
        O: s,
        j: [],
        L: [],
        D: [],
        k: null,
        q: null,
        X: null,
        T: null,
        R: null,
        W: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: 0,
        G: 0,
        K: !0,
        Z: !1,
        tt: {
            nt: new Js({
                O: s,
                et: !0
            }),
            it: new Js({
                O: s,
                et: !1
            })
        }
    };
}

function F(t, n, e, s, o) {
    const r = t ?? L(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.M = e;
        t.N = s;
        t.O = o;
        t.tt.nt.data.O = o;
        t.tt.it.data.O = o;
        t.L.length = 0;
        t.D.length = 0;
    })(r, n, e, s, o);
    return r;
}

const Ho = (t, n, e, s, o, r, i) => D(F(i, t, n, o, r), e, s);

const Jo = (t, n, e, s, o, r, i, c, l = !1, u) => D(F(u, t, n, i, c), e, s, o, r, l);

function D(t, n, e, s = Jl(e), o = null, r = !1) {
    X(t, n, e, s, o, r);
    const i = G(t);
    if (Hi(i)) {
        return i.finally(() => {
            K(t);
        });
    }
    K(t);
}

function X(t, n, e, s = Jl(e), o = null, r = !1) {
    const i = t.Z;
    t.Z = r || i;
    t.k = e;
    t.X = null;
    t.q = s;
    t.T = o;
    t.R = e;
    B(t, n, !0);
    try {
        if (t.k.flags & 32) {
            return;
        }
        for (;t.j.length; ) {
            for (;t.Y < t.G; ) {
                if (typeof t.J === "string") {
                    mt(t, t.J);
                } else if (typeof t.J === "number") {
                    mt(t, t.J + "");
                } else if (t.J && typeof t.J === "object") {
                    if (Ks(t.J)) {
                        const n = t.J.type;
                        if (typeof n === "string") {
                            nt(t);
                            ct(t, t.J, n);
                            const e = t.J.constProps && Qo.call(t.J.constProps, zi) || Qo.call(t.J.varProps, zi);
                            e ? t.X || Z(t, !1) : U(t, t.J.children, !0);
                        } else if (typeof n === "function") {
                            if (n === wo) {
                                nt(t);
                                dt(t, "F", t.J.key);
                                U(t, t.J.children, !0);
                            } else if (n === bo) {
                                nt(t);
                                J(t) || U(t, t.J.children, !0);
                            } else if (n === bt) {
                                H(t);
                                U(t, t.J.children, !0, !0);
                            } else if (n === Eo) {
                                tt(t);
                            } else if (n === go) {
                                tt(t);
                            } else {
                                nt(t);
                                pt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.J)) {
                        U(t, t.J, !1);
                    } else if (Tu(t.J)) {
                        dt(t, "S", null);
                        const n = t.J instanceof Hs ? t.J.rt() : t.J;
                        const e = t.q?.[Wr]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof Hs && (s = xt(e, n));
                        if (!s) {
                            const e = t.X || t.q;
                            U(t, W(t, () => Of(n, e, ".", t.$)), !0);
                        }
                    } else if (Hi(t.J)) {
                        dt(t, "A", null);
                        t.L.push(t.J, t.X || t.q);
                    }
                } else {
                    t.J === _o || mt(t, "");
                }
                V(t);
            }
            tt(t);
            Y(t);
            z(t);
        }
    } finally {
        t.Z = i;
    }
}

function W(t, e) {
    try {
        return e();
    } catch (s) {
        if (Hi(s)) {
            const o = s.then(() => n(e));
            t.L.push(o, t.X || t.q);
            return null;
        }
        throw s;
    }
}

function V(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.Y++;
    if (t.Y < t.G) {
        t.J = t.H[t.Y];
    } else if (t.j.length > 0 && t.j[t.j.length - 1] === !1) {
        return z(t);
    }
    t.X !== null ? t.X = null : t.q = O(t, t.q);
}

function U(t, n, e, s = !1) {
    if (!s && (n == null || e && Be(n) && n.length === 0)) {
        Z(t);
        return;
    }
    B(t, n, e);
    if (e) {
        const n = !s && t.Z || !!t.X || !Jl(t.q);
        t.Z = n;
        t.B = null;
        t.W = null;
        t.U = null;
        t.k = t.X || t.q;
        t.q = Jl(t.k);
        t.X = null;
    }
    t.K = !1;
}

function z(t) {
    const n = t.j.pop();
    if (n) {
        t.Z = t.j.pop();
        t.B = t.j.pop();
        t.W = t.j.pop();
        t.U = t.j.pop();
        t.X = t.j.pop();
        t.q = t.j.pop();
        t.k = t.j.pop();
    }
    t.J = t.j.pop();
    t.G = t.j.pop();
    t.Y = t.j.pop();
    t.H = t.j.pop();
    V(t);
}

function B(t, n, e) {
    t.j.push(t.H, t.Y, t.G, t.J);
    e && t.j.push(t.k, t.q, t.X, t.U, t.W, t.B, t.Z);
    t.j.push(e);
    if (Array.isArray(n)) {
        t.Y = 0;
        t.G = n.length;
        t.H = n;
        t.J = t.G > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.Y = 0;
        t.J = null;
        t.H = null;
        t.G = 0;
    } else {
        t.Y = 0;
        t.J = n;
        t.H = null;
        t.G = 1;
    }
}

function Q(t) {
    if (t.X) {
        return C(t);
    }
    return O(t, t.q) || N(t);
}

function H(t) {
    const n = t.J;
    const e = n.key;
    t.q = bl(t.k, e, n => Tl(t.$.rootVNode, n));
    t.q = t.q && t.q.flags & 32 ? null : t.q;
    if (t.q == null) {
        t.X = hl();
        _l(t.X, li, e);
        t.X.slotParent = t.k;
        _l(t.k, e, t.X);
    }
}

function J(t) {
    const n = t.J;
    const e = gu(t.k);
    const s = k(e, n, t.$);
    const o = Ts(n, ki) || null;
    const r = e ? bl(e, s, null) : null;
    if (r == null) {
        t.X = hl();
        _l(t.X, li, s);
        _l(t.X, ki, o);
        M(t.$, t.X, o);
        e && _l(e, s, t.X);
        Xl(t.M, t.k, t.X, Q(t));
        return !1;
    }
    if (r === t.q) {} else {
        const n = r.parent;
        t.X = r;
        _l(t.X, li, s);
        _l(t.X, ki, o);
        M(t.$, t.X, o);
        e && _l(e, s, t.X);
        Dl(t.M, t.X);
        Xl(t.M, t.k, t.X, Q(t));
        n && pl(n) && !n.firstChild && Bl(n) === Ri && Ul(t.M, n.parent, n, !0);
    }
    return !0;
}

function Y(t) {
    const n = t.B;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            Et(t.$, t.M, e, t.N);
            Ul(t.M, t.k, e, !0);
        }
        n.clear();
        t.B = null;
    }
    t.q = null;
}

function G(t) {
    for (;t.L.length; ) {
        const n = t.L.shift();
        const e = t.L.shift();
        if (Hi(n)) {
            return n.then(n => {
                X(t, n, e);
                return G(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return G(t);
            });
        }
        X(t, n, e);
    }
    if (t.D.length) {
        const n = t.D.splice(0);
        return Promise.all(n).then(() => G(t));
    }
}

function K(t) {
    t.M = null;
    t.N = null;
}

function Z(t, n = !0) {
    const e = t.q && Jl(t.q);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            Et(t.$, t.M, s, t.N);
            s = s.nextSibling;
        }
        zl(t.M, t.q, e, n);
    }
}

function tt(t) {
    const n = N(t);
    if (t.q !== null && t.q !== n) {
        for (;t.q && t.q !== n; ) {
            const n = t.q;
            t.q = O(t, t.q);
            if (t.k === n.parent) {
                Et(t.$, t.M, n, t.N);
                Ul(t.M, t.k, n, !0);
            }
        }
    }
}

function nt(t) {
    if (t.q !== null && ml(t.q)) {
        const n = t.q;
        t.q = O(t, t.q);
        Ul(t.M, t.k, n, !0);
    }
}

function et(t, n, e) {
    if (Tu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw Je(15, [ e ]);
}

function it(t, e, s, o, r) {
    return n(() => Of(o, e, s, t, r));
}

function rt(t, n, e, s, o) {
    const r = t.O;
    const c = s.then(t => E(n, e, i(e, t, r), o));
    t.D.push(c);
}

function st(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(Ei, "html");
    }
}

function ot(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function lt(t, n, e, s) {
    const r = function c(t, n) {
        const e = Vl(t.k, !0);
        const s = o(e, n);
        const r = document;
        const i = s.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(s.elementNamespace, n);
        t.X = cl(i, n);
        t.X.flags |= s.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.X;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (nr(n)) {
                ut(n, o, r, l, t);
                continue;
            }
            if (n === "ref" && et(o, r, s)) {
                continue;
            }
            Tu(o) && (o = it(t.$, t.X, n, o, t.tt.nt));
            if (Hi(o)) {
                rt(t, r, n, o, u);
                continue;
            }
            if (n === zi) {
                st(r, o);
                continue;
            }
            if (e === "textarea" && n === "value" && ot(r, o)) {
                continue;
            }
            E(r, n, i(n, o, t.O), u);
        }
    }
    const a = n.key;
    a && (t.X.key = a);
    if (t.O) {
        const e = Qo.call(n.varProps, "class") || n.constProps && Qo.call(n.constProps, "class");
        e || r.setAttribute("class", t.O);
    }
    Cl(t.M, t.k, t.X, C(t));
}

function ut(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(x.bind(null, n));
                }
            } else {
                e && s.push(x.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = x.bind(null, n));
    }
    t.charAt(2) !== "e" && gl(o.M, s, t, "");
    (function i(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, r);
}

function ct(t, n, e) {
    if (t.Z) {
        lt(t, n, e, null);
    } else {
        const s = t.q && pl(t.q);
        const o = s && e === Bl(t.q);
        const r = n.key;
        const i = s && t.q.key;
        if (o && r === i) {
            at(t, e, r);
        } else {
            const s = ft(e, r);
            ht(t, e, r, s, t.k) && lt(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.X || t.q;
    s && function r(t, n, e, s) {
        t.Z || Sl(t.$, n);
        const o = n.props;
        for (const r in e) {
            const i = e[r];
            if (o && Qo.call(o, r)) {
                const e = o[r];
                Pt(i, e) || Yo(t, n, r, i, s);
            } else {
                i != null && Yo(t, n, r, i, s);
            }
        }
        if (o) {
            for (const r in o) {
                Qo.call(e, r) || r.charAt(0) === ":" || nr(r) || Yo(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const Yo = (t, n, e, s, o) => {
    if (nr(e)) {
        ut(e, s, n.node, n, t);
        return;
    }
    if (e === ji || e === Li) {
        _l(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (et(s, t, o)) {
            return;
        }
    }
    const i = n[Wr]?.get(e);
    if (Tu(s)) {
        const o = s instanceof Hs ? s.rt() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && Rn(t.$, i);
        const r = n;
        s = it(t.$, r, e, o, t.tt.it);
    } else {
        i && Rn(t.$, i);
    }
    if (Hi(s)) {
        const o = n;
        const i = s.then(n => {
            j(t.M, o, e, n, t.O, r);
        });
        t.D.push(i);
        return;
    }
    j(t.M, n, e, s, t.O, r);
};

function ft(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function at(t, n, e) {
    const s = ft(n, e);
    if (s && t.B?.has(s)) {
        t.B.delete(s);
        return !0;
    }
    return !1;
}

function ht(t, n, e, s, o, r) {
    t.X = function i(t, n, e) {
        let s = null;
        if (t.W === null) {
            const o = t.q;
            if (o) {
                const s = pl(o) ? Bl(o) : null;
                const r = wt(o) || vt(o, t.$._);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.W = new Map;
            t.U = [];
            const r = N(t);
            let i = t.q;
            for (;i && i !== r; ) {
                const o = pl(i) ? Bl(i) : null;
                const r = wt(i) || vt(i, t.$._);
                s === null && r == e && o == n ? s = i : r === null ? t.U.push(o, i) : t.W.set(ft(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.U.length; e += 2) {
                if (t.U[e] === n) {
                    s = t.U[e + 1];
                    t.U.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ft(n, e);
            const r = t.W.get(o);
            if (r) {
                s = r;
                t.W.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.q) {
                    const n = pl(t.q) ? Bl(t.q) : null;
                    const e = wt(t.q) || vt(t.q, t.$._);
                    if (e != null) {
                        const s = ft(n, e);
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                        t.W?.delete(s);
                    }
                }
                return;
            }
            const e = N(t);
            let s = t.q;
            for (;s && s !== n && s !== e; ) {
                const n = pl(s) ? Bl(s) : null;
                const e = wt(s) || vt(s, t.$._);
                if (e != null) {
                    const o = ft(n, e);
                    t.B ||= new Map;
                    t.B.set(o, s);
                    t.W?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.X) {
        s || Xl(t.M, o, t.X, C(t));
        t.q = t.X;
        t.X = null;
        return !1;
    }
    if (s != null) {
        const n = t.B?.get(s) || null;
        if (n) {
            t.B.delete(s);
            if (r && t.q) {
                const n = wt(t.q) || vt(t.q, t.$._);
                if (n != null) {
                    const e = pl(t.q) ? Bl(t.q) : null;
                    const s = ft(e, n);
                    if (s != null) {
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                    }
                }
            }
            n !== t.q && Xl(t.M, o, n, C(t));
            t.q = n;
            t.X = null;
            return !1;
        }
    }
    return !0;
}

function dt(t, n, e) {
    const s = n === "F";
    const o = wt(t.q);
    const r = t.q && wl(t.q);
    const i = r && o === e && (!s || !!e);
    if (i) {
        at(t, null, o);
        return;
    }
    if (e === null || t.Z) {
        Ol(t.M, t.k, t.X = hl(), Q(t));
        t.X.key = e;
        return;
    }
    if (ht(t, null, e, ft(null, e), t.k, !0)) {
        Ol(t.M, t.k, t.X = hl(), Q(t));
        t.X.key = e;
    }
}

function pt(t, n) {
    const e = n[$a];
    let s = t.X || t.q;
    const o = t.J;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.st;
        const l = vt(s, t.$._);
        const u = o.key || c;
        const f = wt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                at(t, null, u);
            } else {
                $t(t, s, i, n);
                s = t.X;
                r = !0;
            }
        } else {
            if (ht(t, null, u, u, t.k)) {
                $t(t, s, i, n);
                r = !0;
            }
            s = t.X || t.q;
        }
        if (s) {
            const e = bl(s, Ni, t.$._);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = _t(n[ms], e[ms], e[bs], s, !1);
                        o ||= t;
                        const r = _t(n[ws], e[ws], e[bs], s, !0);
                        o ||= r;
                        e[vs] = n[vs];
                    } else if (n) {
                        _l(t, Ni, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    $t(t, s, i, n);
                    s = t.X;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                _l(s, ri, i);
                s.flags &= -33;
                yn(t.$, s, 4, t.N);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new Ys(bt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            Xe(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (Ks(n) && Ts(n, li) || "") + "";
                const i = De(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            U(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = wt(s);
        const i = e === r;
        const c = vt(s, t.$._);
        const l = c == null;
        if (s && !l || !s) {
            yt(t);
            s = t.X;
        } else if (i) {
            at(t, null, e);
        } else {
            ht(t, null, e, e, t.k) && yt(t);
            s = t.X || t.q;
        }
        if (s) {
            let e = s;
            for (;e && (!wl(e) || bl(e, ri, null) === null); ) {
                e = e.parent || gu(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[ss] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            yn(t.$, s, 8, t.N);
        }
    }
}

function $t(t, n, e, s) {
    n && kn(t.$, n);
    Ol(t.M, t.k, t.X = hl(), Q(t));
    const o = t.J;
    _l(t.X, ri, e);
    _l(t.X, Ni, s);
    t.X.key = o.key;
}

function yt(t) {
    Ol(t.M, t.k, t.X = hl(), Q(t));
    const n = t.J;
    _l(t.X, Ni, n.props);
    n.key && (t.X.key = n.key);
}

function mt(t, n) {
    if (t.q !== null) {
        const e = bu(t.q);
        if (e === 3) {
            if (n !== Ql(t.q)) {
                Hl(t.M, t.q, n);
                return;
            }
            return;
        }
    }
    Cl(t.M, t.k, t.X = al(document.createTextNode(n), n), C(t));
}

function wt(t) {
    if (t == null || ml(t)) {
        return null;
    }
    return t.key;
}

function vt(t, n) {
    if (t == null || ml(t)) {
        return null;
    }
    const e = bl(t, ri, n);
    return e ? e.st : null;
}

function bt() {}

function _t(t, n, e, s, o = !0) {
    if (gt(t) && gt(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === yi) {
                continue;
            }
            const i = t[s];
            const c = n?.[s];
            if (!n || !Pt(i, c) && !Tt(i, c)) {
                if (s === "class") {
                    if (At(i, c)) {
                        continue;
                    }
                } else if (s === "style" && qt(i, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = i);
                    const t = Ps(e, s);
                    t || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === yi) {
                continue;
            }
            if ((!t || !Qo.call(t, s)) && o) {
                delete n[s];
                const t = Ps(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function gt(t) {
    if (!t) {
        return !0;
    }
    return Nr(t);
}

function Et(t, n, e, s = null) {
    let o = e;
    const r = s && dn(s) ? y(s) : null;
    if (ml(e)) {
        Rt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && dn(o) && a(t, r, o);
        const c = o.flags;
        if (c & 3) {
            kn(t, o);
            Rt(o);
            const r = c & 2 && bl(o, ri, null) !== null;
            if (r) {
                const e = t.getHostProp(o, Ci);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (ze(r)) {
                            const n = Ru(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                yn(t, o, 128, s);
                                continue;
                            }
                            (r instanceof ds || r instanceof Hs) && (r.h & 4 || kn(t, r));
                            (n || r instanceof $s) && Bo(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (S(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? Tl(t.rootVNode, e) : e;
                                let c = Jl(o);
                                for (;c; ) {
                                    Et(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                kt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = vl(o);
            if (i) {
                if (o === e) {
                    const n = Jl(o);
                    if (n) {
                        bn(n);
                        return;
                    }
                    St(t, o);
                }
            } else {
                const t = Jl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Rt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function St(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, li);
    e != null && t.getHostProp(n.slotParent, e) === n && _l(n.slotParent, e, null);
}

function kt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && Bl(s) === Ri) {
            St(t, e);
            Ul(n, s, e, !0);
        }
    }
}

function Rt(t) {
    t.flags |= 32;
}

function Pt(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof Hs && n instanceof Hs && Mt(n, t);
}

function Tt(t, n) {
    if (t === n) {
        return !0;
    }
    if (Tu(t) && Tu(n)) {
        const e = t instanceof Hs ? t.rt() : t;
        const s = n instanceof Hs ? n.rt() : n;
        return If(() => e.value === s.value);
    }
    return !1;
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    return cr(t) === cr(n);
}

function At(t, n) {
    if (t === n) {
        return !0;
    }
    return lr(t) === lr(n);
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ot === t.ot && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.lt, t.lt);
}

function xt(t, n) {
    if (!(n instanceof Hs)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof Hs && Mt(s, n)) {
            return !0;
        }
    }
    return !1;
}

const Go = (t, n, e, s, o) => {
    const r = Ae(t.tn, n, t);
    if (e) {
        r.en = m(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, ri));
    if (Ge(s)) {
        o = o || t.getHostProp(n, Ni) || Ss;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (ya(s)) {
        const t = s;
        i = () => qe(r, t, [ o || Ss, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => qe(r, t, [ o || Ss ]);
    }
    const l = Ne;
    const u = (e = 0) => Ji(() => {
        if (!c) {
            t.setHostProp(n, Oi, null);
            t.setHostProp(n, Xi, null);
        }
        e > 0 && dl(n) && kn(t, n);
        return Yi(i(o), t => Yi(r.rn, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < Qi) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Di);
        if (o) {
            return function r(t, n, e) {
                const s = Ot(n);
                let o = n;
                const r = "q-e:qvisible";
                return Yi(s, n => {
                    const s = !n;
                    let i = null;
                    for (const c in e) {
                        if (Object.prototype.hasOwnProperty.call(e, c)) {
                            let l = n;
                            let u = c;
                            if (s) {
                                if (c !== r && !c.startsWith("q-d:") && !c.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!i) {
                                    i = Lt();
                                    const n = Ne;
                                    n && t.ut(i) || (o = jt(o, i));
                                }
                                l = i;
                            }
                            if (l) {
                                l.type === "script" && c === r && (u = "q-d:qinit");
                                Nt(l, u, e[c]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (Hi(t) && e < Qi) {
            return t.then(() => u(++e));
        }
        if (e >= Qi) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Nt(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = rr(n);
    c && Ct(t, f, "capture");
    l && Ct(t, f, "preventdefault");
    u && Ct(t, f, "stoppropagation");
}

function Ct(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === Ss && (t.varProps = {});
    t.varProps[s] = !0;
}

function Ot(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (Ks(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (Be(t)) {
            n.push(...t);
        } else {
            if (Hi(t)) {
                return Yi(t, t => Ot(t));
            }
            if (Tu(t)) {
                return Ot(t.untrackedValue);
            }
        }
    }
    return null;
}

function jt(t, n) {
    if (Ks(t)) {
        if (t.type !== wo && !ya(t.type)) {
            return uo(wo, null, null, [ t, n ], 0, null);
        }
        t.children == null ? t.children = n : Be(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return t;
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        return uo(wo, null, null, [ t, n ], 0, null);
    }
    if (Be(t) && t.length > 0) {
        jt(t[0], n);
        return t;
    }
    return t;
}

function Lt() {
    return new Ys("script", null, {
        hidden: ""
    }, null, 0, null);
}

function Ft(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Dt(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Ft(t[c], c, r, s);
    }
    return i;
}

function Xt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Wt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = Jl(e);
    const f = L(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return Jo(c, n, Dt(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        zl(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return Jo(c, n, Dt(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        zl(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const m = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== m; ) {
            const s = t.nextSibling;
            Ul(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = m;
        return Jo(c, n, Dt(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const w = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const v = function _(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < v.length; t++) {
        const s = v[t];
        const o = s.key;
        if (b.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            Ul(n, e, s, !0);
        }
    }
    const S = new Int32Array(w);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < w; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(w);
    const T = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < T.length; t++) {
        P[R[T[t]]] = 1;
    }
    let M = d;
    let I = m;
    const A = () => {
        for (;M >= h; ) {
            const t = M - h;
            if (P[t] === 1) {
                I = g[S[t]];
                M--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = g[r];
                const s = I === null ? e.lastChild === t : t.nextSibling === I;
                s || Xl(n, e, t, I);
                I = t;
                M--;
                continue;
            }
            let l = M;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = M - l + 1;
            const d = Jo(c, n, Dt(o, a, null, i, l, M), e, I, I, s, null, !0, f);
            return Yi(d, () => {
                const t = Xt(e, I, u);
                I = t;
                M = l - 1;
                return A();
            });
        }
    };
    return A();
}

function Vt(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, Ci);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof ku) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = Su(s, n, t);
                Hi(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Ut(t, n) {
    const e = t.props ||= {};
    e[es] = n;
}

function zt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[is] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[is] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = Il(n, document, r, e);
    const u = pl(r) && i || r;
    const f = u === r ? null : c;
    Cl(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Bt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[es];
    }(t);
    if (!r) {
        return;
    }
    Ut(t, null);
    Tu(r) && (r = r.value);
    return Ho(n, e, r, o, s, null);
}

function Qt(t, n, e, s) {
    const o = t;
    const r = n.getHostProp(o, ri);
    if (r && !r.resolved) {
        return r.resolve();
    }
    t.dirty &= -5;
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, Ni) || null;
    return Jt(n, o, o, r, i, e, s);
}

function Ht(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[ss] || null;
        e && delete n[ss];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return Jt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function Jt(t, e, s, o, r, i, c) {
    const l = Ji(() => Go(t, e, s, o, r), s => {
        const o = t.getHostProp(e, pi);
        return n(() => Ho(t, i, s, e, c, tr(o)));
    }, n => {
        t.handleError(n, e);
    });
    if (Hi(l)) {
        return l;
    }
    return;
}

function Yt(t, n, e, s, o, r = null) {
    n.push(Do(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Gt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[ns] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        Tu(e) && (e = e.value);
        const r = s.isConst;
        Yt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[ns];
    })(t);
}

function Kt(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, Ci);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof ku && n.h & 16) {
            n.h &= -17;
            const t = n;
            Bo(t);
        }
    }
}

function Zt(t, e) {
    t.dirty &= -33;
    const s = e.getHostProp(t, rs);
    if (!s) {
        return;
    }
    const o = s.ct;
    const r = Me();
    r.$ = e;
    return Yi(n(() => Te.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return Iu(e, s, o);
        }
    });
}

function tn(t, n, e, s) {
    t.dirty &= -257;
    const o = t;
    const r = n.getHostProp(o, Ni) || null;
    if (!r) {
        return;
    }
    let i = qs(r, "items");
    Tu(i) && (i = If(i));
    const c = qs(r, "key$");
    const l = qs(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Wt(n, e, o, s, i, u, f);
    }
    return Yi(c.resolve(), t => Yi(l.resolve(), r => Wt(n, e, o, s, i, t, r)));
}

let Ko = null;

const Zo = (t, n, e) => {
    Ko || (Ko = t.insertBefore);
    Ko.call(t, n, e);
};

function nn(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const r = () => {
        if (s) {
            if (s.length === 1) {
                Zo(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                Zo(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof No) {
            if (n === l.parent && e === l.beforeTarget) {
                s || (s = []);
                s.push(l.target);
                o.add(l.target);
                continue;
            }
            if (!s) {
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (n === l.parent) {
                r();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (o.has(l.target) || e && l.target === e || n && l.target === n) {
                r();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            Zo(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof Mo) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && r();
            l.target.remove();
            continue;
        }
        if (l instanceof xo) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && r();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof Io) {
            l.target.nodeValue = l.text;
        } else if (l instanceof Co) {
            const t = l.target;
            const e = l.attrName;
            const s = l.attrValue;
            const o = s != null ? i(e, s, l.scopedStyleIdPrefix) : null;
            const c = o == null || o === !1;
            if (tl(t, e)) {
                t[e] = nl(o);
            } else if (e === zi) {
                n === t && r();
                t.innerHTML = o;
                t.setAttribute(Ei, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : E(t, e, o, l.isSvg);
            }
        }
    }
    r();
}

const tl = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const nl = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const el = (t => () => queueMicrotask(t))(sn);

const rl = ar(sn);

let sl = !1;

function en() {
    if (!sl) {
        sl = !0;
        el();
    }
}

function rn() {
    if (!sl) {
        sl = !0;
        rl();
    }
}

function sn() {
    sl = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (on(e, n)) {
            rn();
            return;
        }
    }
}

function on(t, n) {
    const e = Ne;
    const s = y(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        ln(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 1023)) {
            __EXPERIMENTAL__.suspense && T(l);
            p(r, s, fn(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 128) {
                Kt(l, r);
            } else if (l.dirty & 64) {
                const n = cn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -1024;
            p(r, s, fn(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Vt(l, r, s);
            } else if (l.dirty & 2) {
                e = Bt(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Qt(l, r, i, t);
            } else if (l.dirty & 8) {
                e = Ht(l, r, i, t);
            } else if (l.dirty & 256) {
                e = tn(l, r, i, t);
            } else if (l.dirty & 16) {
                Gt(l, i);
            } else if (l.dirty & 32) {
                e = Zt(l, r);
            } else if (l.dirty & 64) {
                const n = cn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 512 && zt(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && Hi(e)) {
            R(s, l);
            const n = e;
            s.promise = n;
            c(t, r);
            const o = l;
            n.catch(t => {
                s.promise === n && r.handleError(t, o);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                f(t, r);
                en();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    ln(r, t, s, e);
}

function ln(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        h(n, t);
        s || function o(t, n) {
            const e = y(t);
            const s = e.journal;
            if (s && s.length > 0) {
                nn(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    Su(s, t, s.ft);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.pending.value = Math.max(0, e.pending.value - 1);
                e.version.value++;
            }
        })(e);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                un(t);
            });
            return;
        }
        un(t);
    }
}

function un(t) {
    t.ht();
}

function cn(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        T(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = fn(o[0], s, t);
    p(t, n, i);
    return i;
}

function fn(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && an(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && T(s);
    return fn(s, n, e);
}

function an(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    if (!n.props || !(ki in n.props) || !t.getHostProp(n, ki)) {
        return !1;
    }
    dn(n) || hn(t, n, 0);
    return !0;
}

function hn(t, n, e) {
    if (dn(n)) {
        en();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        ts.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    l(t, r);
    en();
    return r;
}

function dn(t) {
    return (t.flags & 256) !== 0;
}

function pn(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 16 && function e(t, n) {
            n.dirty &= -17;
            const e = n.getProp(ns);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                Tu(e) && (e = e.value);
                const r = i(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, r);
            }
        }(t, n);
        n.dirty & 32 && Zt(n, t);
        n.dirty &= -1024;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(Ci);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof ku) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = Su(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        Hi(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            const e = n;
            const s = t.getHostProp(e, Ni) || null;
            if (!s) {
                return;
            }
            let o = qs(s, "items");
            Tu(o) && (o = If(o));
            const r = await qs(s, "key$").resolve();
            const i = await qs(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const ol = [];

function $n(t) {
    for (let n = 0; n < ol.length; n++) {
        const e = ol[n];
        const s = ol[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function yn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return Ne;
    }()) {
        const e = pn(t, n);
        Hi(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function e(t, n, s) {
            ol.push(n);
            let o = P(t, n);
            let r = n.slotParent || n.parent;
            for (;r; ) {
                const e = r.dirty & 1023;
                const i = dn(r);
                __EXPERIMENTAL__.suspense && (o ||= P(t, r) || (e ? q(t, r) : null));
                if (r === s || e) {
                    A(n, o);
                    $n(r);
                    if (i) {
                        const t = y(r);
                        t.position !== r && (t.position = n);
                    }
                    ol.length = 0;
                    return;
                }
                if (i) {
                    const t = y(r);
                    t.position !== r && (t.position = n);
                }
                ol.push(r);
                r = r.slotParent || r.parent;
            }
            ol.length = 0;
            ((t, ...n) => {
                const e = Fe(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(t, n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        A(n, P(t, n) || q(t, c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (dn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = y(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        dn(n) ? A(n, P(t, n)) : function l(t, n) {
            ol.push(n);
            let e = __EXPERIMENTAL__.suspense ? P(t, n) : null;
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const o = dn(s);
                __EXPERIMENTAL__.suspense && (e ||= P(t, s) || (o ? q(t, s) : null));
                if (o) {
                    A(n, e);
                    $n(s);
                    ol.length = 0;
                    return !0;
                }
                ol.push(s);
                s = s.slotParent || s.parent;
            }
            A(n, e);
            ol.length = 0;
            return !1;
        }(t, n) || hn(t, n, 0);
    }
}

function mn(t, n) {
    t.push(n);
}

const ll = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const ul = t => {
    let n = null;
    return e => {
        n || (n = ll(e, t));
        return n.call(e);
    };
};

const cl = (t, n, e = null) => {
    const s = new Yr(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const fl = t => {
    const n = new Yr(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const al = (t, n) => {
    const e = new Gr(-4084, null, null, null, null, t, n);
    return e;
};

const hl = () => {
    const t = new Jr(null, -4094, null, null, null, null, null, null);
    return t;
};

const dl = t => t instanceof Hr;

const pl = t => (t.flags & 1) === 1;

const $l = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const yl = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const ml = t => (t.flags & 4) === 4;

const wl = t => (t.flags & 2) === 2;

const vl = t => {
    const n = t.flags;
    return (n & 2) === 2 && bl(t, li, null) !== null;
};

const id = t => t;

const bl = (t, n, e) => {
    if (pl(t) || wl(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const _l = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const gl = (t, n, e, s, o = null) => {
    if (pl(n)) {
        _l(n, e, s);
        mn(t, Do(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const El = t => {
    if (t.key) {
        return;
    }
    const n = tu(t.node, Ui);
    n && (t.key = n);
};

const Sl = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (nr(c)) {
                wn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== Ui && c) {
                if (c.startsWith(Ei)) {
                    const t = i.value;
                    t === "html" ? _l(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && _l(e, "value", s.value);
                } else {
                    const t = i.value;
                    _l(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        bl(e, ji, null) === null && bl(e, Li, null) === null || (n.flags |= 64);
    }
};

const kl = t => {
    if (t.bt === "_run") {
        const n = t.getCaptured()?.[0];
        if (Ge(n)) {
            return n;
        }
    }
    return t;
};

function wn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = kl(Ln(i[t], e));
        c.push(x.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function vn(t, n, e) {
    let s = Jl(n);
    for (;s; ) {
        if (ml(s)) {
            Pl(t, s);
            e(s, n);
        } else {
            pl(s) ? e(s, n) : vn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function bn(t) {
    let n = t;
    if (ml(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = Jl(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const Rl = (t, n, e) => {
    let s = t;
    for (;e && s && wl(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !wl(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !wl(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (ml(t) && e && pl(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && yu(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Pl = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Wl(n, !0);
        const o = e.node;
        const r = fu(s);
        let i = Rl(n, !1, !0);
        const c = Rl(n, !0, !0);
        const l = o || (c && pl(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && ml(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                mn(t, Fo(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = Rl(i, !1, !0);
        }
        i = n;
        for (;i && ml(i); ) {
            const n = Rl(i, !0, !0);
            const e = !n || !ml(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    mn(t, Lo(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    mn(t, Fo(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const Tl = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const s = t.vNode;
        if (s) {
            return s;
        }
        if (__EXPERIMENTAL__.suspense && t._qSegment) {
            e = fl(i);
            El(e);
            t.vNode = e;
            return e;
        }
    }
    if (dl(i)) {
        e = i;
    } else {
        if (__EXPERIMENTAL__.suspense && i._qSegment) {
            e = i.vNode || fl(i);
            El(e);
        } else {
            let t = i;
            const n = [ i ];
            for (;t && t !== s && !t.vNode; ) {
                t = t.parentElement;
                n.push(t);
            }
            t.vNode && (e = t.vNode);
            for (let t = n.length - 2; t >= 0; t--) {
                e = Ml(e, n[t]);
            }
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = xl(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = ql(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const ql = (t, n) => {
    let e = Jl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Al = [];

const Ml = (t, n) => {
    let e = Jl(t);
    for (;e && (!(e instanceof Yr) || e.node !== n); ) {
        if (wl(e)) {
            const t = e.nextSibling;
            const n = Jl(e);
            if (n) {
                t && Al.push(t);
                e = n;
            } else {
                e = t || (Al.length ? Al.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Al.pop();
        }
    }
    for (;Al.length; ) {
        Al.pop();
    }
    return e;
};

const xl = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const Il = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = cl(o, "errored-host");
    if ($l(e)) {
        Xl(t, r, e, null);
    } else {
        const n = [];
        vn(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Xl(t, r, n[e], null);
        }
    }
    return r;
};

const Nl = nn;

const Cl = (t, n, e, s) => {
    const o = pl(n);
    o && Yl(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    Fl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Wl(n, !1);
    l && !c && mn(t, Fo(i, l, jl(t, n, s)?.node ?? null));
    Ll(n, e, s);
    c && (e.flags |= 32);
};

const Ol = (t, n, e, r) => {
    const i = pl(n);
    i && Yl(n);
    const c = e.parent;
    if (e === r) {
        if (c) {
            return;
        }
        r = null;
    }
    Fl(t, c, n, e);
    const l = n.flags & 32;
    const u = !i && n.flags & 2048 ? n.props?.[si] : null;
    const f = u ? null : i ? n : Vl(n, !1);
    const a = u || f?.node;
    const h = jl(t, n, r);
    const d = h?.node ?? null;
    const p = vl(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const i = Vl(n, !1);
        const c = jl(t, n, r)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(i, e);
        vn(t, e, n => {
            if (ml(n)) {
                mn(t, Fo(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, r, i) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (pl(c)) {
                                e = c.node;
                                const t = Bl(c);
                                const l = c.parent;
                                const h = u == null ? n : l && Vl(l, !0);
                                if (h) {
                                    const t = o(h, Bl(c));
                                    r = t.elementNamespace;
                                    i = t.elementNamespaceFlag;
                                }
                                const d = Jl(c);
                                a = s(e, t, r, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= i;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (Kl(e)) {
                                    const t = Ee(e);
                                    if (t) {
                                        const n = Jl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, i, l, u);
                    t && (n.node = t);
                }
                mn(t, Fo(n.node, a, c));
            }
        });
    } else {
        a && !l && vn(t, e, n => {
            mn(t, Fo(n.node, a, d));
        });
    }
    Ll(n, e, r);
    l && (e.flags |= 32);
};

const jl = (t, n, e) => {
    let s = null;
    e == null ? wl(n) && (s = Rl(n, !0, !1)) : s = wl(e) ? Rl(e, !0, !0) : e;
    s && ml(s) && Pl(t, s);
    return s;
};

const Ll = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Fl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && Ul(t, n, s, !1);
};

const Dl = (t, n) => {
    let e = n;
    for (;e && wl(e); ) {
        e = e.lastChild;
    }
    e && ml(e) && (e.flags & 8) === 0 && Pl(t, e);
};

const Xl = (t, n, e, s) => {
    $l(e) ? Cl(t, n, e, s) : Ol(t, n, e, s);
};

const Wl = (t, n) => {
    for (;t && !pl(t); ) {
        if (t.flags & 2048) {
            return t.props?.[si];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const Vl = (t, n) => {
    for (;t && !pl(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const Ul = (t, n, e, s) => {
    ml(e) && Pl(t, e);
    if (s) {
        const s = bl(n, zi, null) !== null;
        if (s) {
            return;
        }
        $l(e) ? mn(t, Oo(e.node)) : vn(t, e, n => {
            mn(t, Oo(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const zl = (t, n, e, s = !0) => {
    const o = Wl(n, !0);
    if (o && s) {
        if ($l(n)) {
            mn(t, jo(n.node));
        } else {
            const e = Vl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? mn(t, jo(o)) : vn(t, n, n => {
                mn(t, Oo(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const Bl = t => {
    const n = id(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = cu(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = uu(t);
            switch (n) {
              case qi:
                return 512;

              case Ai:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const Ql = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const Hl = (t, n, e) => {
    Pl(t, n);
    n.text = e;
    mn(t, Lo(n.node, e));
};

const Jl = t => {
    if (ml(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.suspense && n === void 0 && pl(t) && function e(t) {
        const n = t.getAttribute(nd);
        if (n === null) {
            return !1;
        }
        const e = lu(t);
        return _u(e) && e.localName === "template" && e.getAttribute(fi) === n && ru(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = Yl(t));
    return n;
};

const Yl = n => {
    const e = id(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && Kl(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = lu(e);
            const o = fu(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                El(n);
                __EXPERIMENTAL__.suspense && e._qSegment;
                if (o) {
                    if (o.charCodeAt(0) === ei && o.charCodeAt(1) === ei) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = au(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = _u(t);
                            return !n || n && Sn(t);
                        };
                        let p = null;
                        hu(e, ($, y, m, w, b) => {
                            if (mu($())) {
                                for (;d(o); ) {
                                    o = ru(o);
                                    if (!o) {
                                        throw Je(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;mu($()); ) {
                                    t *= 10;
                                    t += m() - 48;
                                }
                                for (;t--; ) {
                                    const n = fl(o);
                                    El(n);
                                    u(n);
                                    o = ru(o);
                                    for (;_u(o) && Sn(o); ) {
                                        o = ru(o);
                                        if (!o && t > 0) {
                                            throw Je(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                _l(n, pi, y());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                _l(n, ri, y());
                            } else if ($() === 61) {
                                h || (h = ge(s));
                                const t = y();
                                h.Xn(parseInt(t, 10), n);
                            } else if ($() === 62) {
                                _l(n, Ni, y());
                            } else if ($() === 64) {
                                const e = w(b + 1) === ei;
                                let s;
                                if (e) {
                                    m();
                                    s = decodeURIComponent(t(y()));
                                    m();
                                } else {
                                    s = y();
                                }
                                n.key = s;
                            } else if ($() === 91) {
                                _l(n, Ci, y());
                            } else if ($() === 94) {
                                _l(n, Oi, y());
                            } else if ($() === 96) {
                                h || (h = ge(s));
                                gn(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = ge(s));
                                n.slotParent = Tl(h.rootVNode, y());
                            } else if ($() === 93) {
                                _l(n, $i, y());
                            } else if ($() === 123) {
                                m();
                                u(hl());
                                vu.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === ei) {
                                const e = y();
                                const s = t(e);
                                const o = b + e.length + 1;
                                const r = w(o + 1) === ei;
                                let i;
                                if (r) {
                                    m();
                                    i = decodeURI(t(y()));
                                    m();
                                } else {
                                    i = t(y());
                                }
                                _l(n, s, i);
                            } else if ($() === 125) {
                                m();
                                n.lastChild = c;
                                r = vu.pop();
                                l = vu.pop();
                                c = vu.pop();
                                i = vu.pop();
                                n = vu.pop();
                            } else if ($() === 126) {
                                const e = t(y());
                                _l(n, li, e);
                            } else {
                                for (;_u(o) && Sn(o); ) {
                                    o = ru(o);
                                }
                                const t = o && nu(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;wu($()); ) {
                                    n += m() - 97;
                                    n *= 26;
                                }
                                n += m() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new Gr(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = ge(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return au(n, s, void 0);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let Gl = null;

const Kl = t => {
    Gl || (Gl = t.hasAttribute);
    return Gl.call(t, Ei);
};

let Zl = null;

const tu = (t, n) => {
    Zl || (Zl = t.getAttribute);
    return Zl.call(t, n);
};

const nu = ul("nodeType");

const eu = t => {
    const n = nu(t);
    return n === 3 || n === 1;
};

let iu = null;

const ru = t => {
    iu || (iu = ll(t, "nextSibling"));
    ou || (ou = ll(t, "firstChild"));
    for (;t; ) {
        t = iu.call(t);
        if (t !== null) {
            const n = nu(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(_i)) {
                    return _n(t, vi, iu, ou);
                }
                if (t.nodeValue?.startsWith(bi)) {
                    return _n(t, [ vi, gi ], iu, ou);
                }
                if (n?.startsWith(Ei)) {
                    for (;t && (t = iu.call(t)) && (nu(t) !== 8 || !t.nodeValue?.startsWith(Si)); ) {}
                }
            }
        }
    }
    return t;
};

function _n(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = su(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const su = ul("parentNode");

let ou = null;

const lu = t => {
    ou || (ou = ll(t, "firstChild"));
    t = t && ou.call(t);
    if (t && nu(t) === 8) {
        iu || (iu = ll(t, "nextSibling"));
        if (t.nodeValue?.startsWith(_i)) {
            return _n(t, vi, iu, ou);
        }
    }
    for (;t && !eu(t); ) {
        t = ru(t);
    }
    return t;
};

const uu = ul("namespaceURI");

const cu = ul("nodeName");

const fu = ul("ownerDocument");

const au = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;_u(i) && Sn(i); ) {
            i = ru(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = nu(i);
        let e = null;
        if (n === 3) {
            e = al(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = fl(i);
            El(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = ru(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        hu(e, (e, s) => {
            if (e() === 61) {
                n || (n = ge(t.node));
                const e = s();
                n.Xn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = ge(t.node));
                gn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function gn(t, n, e) {
    if (t[Wr]) {
        const s = t[Wr];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e._(n));
    } else {
        Object.defineProperty(t, Wr, {
            get() {
                const s = e._(n);
                t[Wr] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, Wr, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const hu = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e);
    }
};

const du = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        Sl(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(Ui) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const pu = (t, n) => {
    let e = $u(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = $u(e);
    }
    return !1;
};

const $u = t => t.parent || t.slotParent;

const yu = t => {
    if (t === null || wl(t)) {
        return null;
    }
    return t.node;
};

function En(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (pl(e)) {
                        const t = Se(e.node);
                        if (!t) {
                            return null;
                        }
                        return Ee(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (ml(i)) {
            c.push(Mn(Ql(i)));
        } else if (wl(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = du(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== Ke && e !== "__scopedStyleIdPrefix__") {
                        const t = bl(i, e, null);
                        s.push(" " + e + "=" + Mn(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (Ze[bl(i, Ke, null) || "V"] || Ze.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Jl(i);
            u && c.push("  " + En.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (pl(i)) {
            const s = Bl(i);
            const l = [];
            dn(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? du(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = bl(i, n, null);
                l.push(" " + n + "=" + Mn(e));
            }
            const f = yu(i);
            if (f) {
                const t = fu(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + Mn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + Mn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (yl(i) || e) {
                const e = Jl(i);
                e && c.push("  " + En.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const mu = t => 48 <= t && t <= 57;

const wu = t => 97 <= t && t <= 122;

function Sn(t) {
    return !t.hasAttribute(Ui) || t.nodeName === "STYLE" && (t.hasAttribute(pi) || t.hasAttribute(ai));
}

const vu = [];

const bu = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw Je(26, [ n ]);
};

const _u = t => t && typeof t == "object" && nu(t) === 1;

const gu = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!wl(t) || bl(t, ri, null) === null); ) {
            const e = t.slotParent;
            const s = wl(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function kn(t, n) {
    dl(n) && pl(n) && Yl(n);
    const e = n[Wr];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        Rn(t, n);
    }
    e.clear();
}

function Rn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof $s) {
            Tn(s, n);
        } else if (s instanceof hs) {
            Pn(t, s, n);
        } else if (xs(s)) {
            const t = s[bs];
            qn(t, n);
        } else if (t.dt.has(s)) {
            const e = t.dt.get(s);
            const o = Fu(e);
            qn(o, n);
        }
    }
    e.clear();
}

function Pn(t, n, e) {
    const s = n.ct;
    s && s.has(e) && s.delete(e);
    if (n instanceof Hs && !s?.size) {
        n.m = void 0;
        kn(t, n);
    }
}

function Tn(t, n) {
    const e = t.ct;
    e && e.has(n) && e.delete(n);
    const s = t.$t;
    s && s.has(n) && s.delete(n);
    const o = t.yt;
    o && o.has(n) && o.delete(n);
    t.wt();
}

function qn(t, n) {
    const e = t?.ct;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Eu = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = Xo();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new ku(6 | i, r, o.m, t, null);
    s(c);
    const l = o.$;
    const {rn: u} = o;
    const f = Yi(u, () => Su(c, l, o.m));
    Hi(f) && (o.rn = f);
};

const Su = (t, n, e) => {
    const s = t.Wn;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let r = null;
    const i = Yi(((t, n) => {
        const e = t.Vn;
        if (e) {
            return e;
        }
        const s = t.ln;
        if (!s) {
            return;
        }
        t.ln = null;
        try {
            const e = s();
            if (Hi(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Vn === s && (t.Vn = void 0);
                });
                t.Vn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = Me(n.tn, e, "qTask");
        s.$ = n;
        const i = t.vt.getFn(s, () => kn(n, t));
        const c = as(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.ln = () => {
                            t.ln = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    Hi(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return Ji(() => i(u), l, s => {
            if (Hi(s)) {
                return s.then(() => {
                    t.Wn === r && (t.Wn = null);
                    return Su(t, n, e);
                });
            }
            o(s);
        });
    });
    if (Hi(i)) {
        r = i.finally(() => {
            t.Wn === r && (t.Wn = null);
        });
        t.Wn = r;
        return r;
    }
    return i;
};

class ku extends Vr {
    h;
    It;
    ft;
    vt;
    ln;
    Vn;
    Wn=null;
    constructor(t, n, e, s, o) {
        super();
        this.h = t;
        this.It = n;
        this.ft = e;
        this.vt = s;
        this.ln = o;
    }
}

const Ru = t => t instanceof ku;

function An(t, n) {
    const e = ge(n);
    return kf(e, () => {
        typeof this === "string" && Gf(Kf(e, this));
        const t = Yf[0];
        t.h |= 4;
        yn(e, t.ft, 1);
    });
}

const Pu = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const Tu = t => t instanceof hs;

const qu = (t, n) => {
    t.add(n);
};

const Au = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Mu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Ru(e) ? o = e.vt : e instanceof ds ? o = e.Ct : s === ":" && (o = n.getHostProp(e, ri));
        o && n.serializationCtx.xt.add(o);
    }
};

const xu = (t, n) => {
    if (t && (!n || t === n || rd(t))) {
        return t;
    }
    return n;
};

const Iu = (t, n, e) => {
    const s = Ce;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (Ru(o)) {
                o.h |= 4;
                yn(t, o.ft, 1);
            } else if (o instanceof hs) {
                o.invalidate();
            } else if (r === ":") {
                yn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Ut(o, n);
                    yn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof Js) {
                    const e = i.data;
                    const c = {
                        isConst: e.et,
                        scopedStyleIdPrefix: e.O,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[ns];
                            if (!o) {
                                o = new Map;
                                s[ns] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(ns);
                        if (!n) {
                            n = new Map;
                            t.setProp(ns, n);
                        }
                        n.set(r, c);
                    }
                    yn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const Nu = t => ze(t) && typeof t[hf] === "function";

const Cu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const Ou = t => {
    t.h |= 4;
};

const ju = [];

function Mn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Ru(t)) {
            return `Task(${Mn(t.vt)})`;
        }
        if (Ge(t)) {
            return `Qrl(${t.bt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (ju.includes(t)) {
                return "*";
            }
            ju.length;
            try {
                ju.push(t);
                if (Array.isArray(t)) {
                    return dl(t) ? "(" + (bl(t, Ke, null) || "vnode") + ")" : t.map(Mn);
                }
                if (Tu(t)) {
                    return t instanceof Hs ? "WrappedSignal" : t instanceof ds ? "ComputedSignal" : "Signal";
                }
                if (Uu(t)) {
                    return "Store";
                }
                if (Ks(t)) {
                    return Lu(t);
                }
                if (dl(t)) {
                    return "(" + (bl(t, Ke, null) || "vnode") + ")";
                }
            } finally {
                ju.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Lu = t => {
    if (Ks(t)) {
        if (typeof t.type === "function") {
            const n = t.type[$a];
            if (n) {
                const [t] = n;
                return "Component(" + t.bt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + Mn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Lu(e);
                    }
                } else {
                    n += Lu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Fu = t => t[cs];

const Du = t => t?.[us] || null;

const Xu = (t, n) => {
    const e = Fu(t);
    e && e.force(n);
};

const Wu = (t, n) => {
    const e = Fu(t);
    if (e) {
        return (e.ct?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Vu = t => Du(t) || t;

const Uu = t => us in t;

function xn(t, n, e) {
    return new Proxy(n, new Bu(e, t || null));
}

const zu = (t, n, e) => {
    if (Ue(t) && e) {
        let s = e.dt.get(t);
        if (!s) {
            s = xn(e, t, n);
            e.dt.set(t, s);
        }
        return s;
    }
    return t;
};

class Bu {
    h;
    $;
    ct=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Du(this);
        Iu(this.$, this, Cn(n, t, this.ct));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === us) {
                return t;
            }
            if (n === cs) {
                return this;
            }
            return t[n];
        }
        const e = qf();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.en;
            o && In(t, Array.isArray(t) ? fs : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && ze(s) && !Object.isFrozen(s) && !Uu(s) && !Object.isFrozen(t)) {
            return zu(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? Vu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && Nn(n, s, t, this);
        } else {
            Nn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || Iu(this.$, this, Cn(t, n, this.ct));
        return !0;
    }
    has(t, n) {
        if (n === us) {
            return !0;
        }
        if (typeof n === "string") {
            const e = qf();
            if (e) {
                const s = e.en;
                s && In(t, Array.isArray(t) ? fs : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = qf();
        const e = n?.en;
        e && In(t, fs, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function In(t, n, e, s, o) {
    const r = e.ct ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = Ne;
    const l = __EXPERIMENTAL__.suspense && e instanceof Bu && c;
    qu(i, s);
    Au(s, t);
    if (c) {
        const i = xu(o, e.$);
        l && i?.vn?.(t, s, n, r);
        Mu(s, i);
    }
}

function Nn(t, n, e, s) {
    e[t] = n;
    const o = Cn(e, t, s.ct);
    o && Iu(s.$, s, o);
}

function Cn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(fs);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const Qu = Symbol();

const Hu = [ void 0, null, !0, !1, "", Es, Ss, os, fs, gs, bo, wo, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER, ":", ".", "id", "ref" ];

const Ju = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER", "':'", "'.'", "'id'", "'ref'" ];

const Yu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch", "SubscriptionDataConstTrue", "SubscriptionDataConstFalse", "EffectSubscriptionNoData" ];

function On(t, n, e) {
    let s = n.bt;
    let o = n._t;
    const r = yr();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => Ge(t) && t.bt == Ye)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.gt(null, 0, e) + "";
    } else {
        o || (o = t.Et(n.st));
        if (!o) {
            throw Je(14, [ n.bt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    if (c && c.length > 0) {
        let n = 0;
        let e = "";
        for (let s = 0; s < c.length; s++) {
            const o = t.St(c[s]);
            const r = o - n;
            n = o;
            e += (s === 0 ? "" : " ") + r;
        }
        l = e;
    }
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function jn(t, n, e, s) {
    return ea(t, n, null, null, e, s);
}

function Ln(t, n) {
    const e = t.indexOf("#");
    const s = t.indexOf("#", e + 1);
    const o = t.slice(0, e);
    const r = s === -1 ? t.slice(e + 1) : t.slice(e + 1, s);
    const i = s !== -1 && s + 1 < t.length ? t.slice(s + 1) : null;
    return jn(o, r, i, n);
}

class Gu {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class Ku {
    zn;
    Bn=0;
    Rt=[];
    Qn=0;
    Hn=new Set;
    Jn=new Map;
    Yn;
    Gn=new Map;
    Kn=0;
    Wt;
    Zn=typeof Temporal !== "undefined";
    constructor(t) {
        this.zn = t;
        this.Wt = t.Wt;
    }
    async serialize() {
        const t = this.Kn;
        this.Kn = 0;
        try {
            await this.outputRoots();
        } finally {
            this.Kn = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.Kn;
        this.Kn = s;
        this.Wt.write(jr);
        this.zn.te = 0;
        try {
            this.Wt.write(t + "");
            this.Wt.write(Fr);
            this.Wt.write(jr);
            await this.outputSelectedRoots(n);
            this.Wt.write(Lr);
            const s = this.getForwardRefsPayload();
            this.zn.te = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Wt.write(Fr);
                s ? this.outputForwardRefsArray(s) : this.Wt.write("0");
            }
            if (e !== void 0) {
                this.Wt.write(Fr);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Wt.write(Or);
                    this.writeRootRefPath(e);
                    this.Wt.write(Or);
                }
            }
        } finally {
            this.Kn = o;
        }
        this.Wt.write(Lr);
    }
    ne(t) {
        this.Wt = t;
    }
    outputArray(t, n, e) {
        this.Wt.write(jr);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Wt.write(Fr) : s = !0;
            e(t[n], n);
        }
        this.Wt.write(Lr);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    rebaseQrlCaptureDeltas$(t, n) {
        let e = 0;
        let s = t;
        const o = n.split(" ");
        for (let t = 0; t < o.length; t++) {
            const n = e + +o[t];
            o[t] = n - s + "";
            e = n;
            s = n;
        }
        return o.join(" ");
    }
    outputShortStringConstant$(t) {
        switch (t) {
          case ":":
            this.output(3, 18);
            return !0;

          case ".":
            this.output(3, 19);
            return !0;

          case "id":
            this.output(3, 20);
            return !0;

          case "ref":
            this.output(3, 21);
            return !0;

          default:
            return !1;
        }
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : Or + t + Or;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Wt.write(n.slice(s, e));
            this.Wt.write("<\\/");
            s = e + 2;
        }
        this.Wt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Wt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Wt.writeRootRefPath(t);
    }
    writeRootRefDelta(t, n) {
        this.Wt.writeRootRefDelta(t, n);
    }
    outputStringChunks(t) {
        this.Wt.write(Or);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Wt.write(e) : typeof e === "number" ? this.writeRootRef(e) : "base" in e ? this.writeRootRefDelta(e.id, e.base) : this.writeRootRefPath(e.path);
        }
        this.Wt.write(Or);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Wt.write(t + Fr);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Wt.write(Or);
                this.writeRootRefPath(n);
                this.Wt.write(Or);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Wt.write(t + Fr);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Wt.write(t + Fr + n);
        } else if (typeof n === "string") {
            this.Wt.write(t + Fr);
            this.outputString(n);
        } else {
            this.Wt.write(t + Fr);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.zn.getSeenRef(t);
        const o = !e && this.Jn.get(t);
        if (s) {
            s.Yn && this.isSeenInStreamedRoot(s) && (s = this.zn.ee(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.zn.ie(t, this.Yn, n);
            }
            s = this.zn.St(t, !0);
        }
        if (s.Yn) {
            if (this.Yn) {
                this.zn.re(s, t);
            } else {
                this.zn.re(s, t, n);
                t = this.zn.se[n];
            }
        }
        if (typeof o === "number") {
            this.Rt[o] = s.It;
            this.Jn.delete(t);
        }
        const r = t instanceof uc ? t.oe : s.It;
        if (!this.Yn && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.Yn; ) {
            t = t.Yn;
        }
        return t.It < this.Kn;
    }
    writeValue(t, n) {
        if (cf(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                if (t.length === 0) {
                    this.output(3, 4);
                } else {
                    if (this.outputShortStringConstant$(t)) {
                        break;
                    }
                    (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                }
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === os) {
                    this.output(3, 7);
                } else if (t === fs) {
                    this.output(3, 8);
                } else if (t === gs) {
                    this.output(3, 9);
                } else {
                    if (t !== Qu) {
                        throw Je(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === bo) {
                    this.output(3, 10);
                } else if (t === wo) {
                    this.output(3, 11);
                } else if (Ge(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = On(this.zn, t, !0);
                        let o;
                        if (n !== "") {
                            const r = this.zn.St(n);
                            const i = this.zn.St(e);
                            const c = s ? this.rebaseQrlCaptureDeltas$(i, s) : null;
                            o = [ r, "#", {
                                id: i,
                                base: r
                            } ];
                            if (s) {
                                let t = 0;
                                let n = i;
                                let e = 0;
                                o.push("#");
                                for (let r = 0; r <= s.length; r++) {
                                    if (r === s.length || s[r] === " ") {
                                        if (r > e) {
                                            const i = t + +s.slice(e, r);
                                            e > 0 && o.push(" ");
                                            o.push({
                                                id: i,
                                                base: n
                                            });
                                            t = i;
                                            n = i;
                                        }
                                        e = r + 1;
                                    }
                                }
                            }
                            const l = `${r}#${i - r}${c ? "#" + c : ""}`;
                            const u = this.Gn.get(l);
                            if (u) {
                                const t = this.zn.St(u);
                                this.output(1, t);
                                return;
                            }
                            this.Gn.set(l, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!ya(t)) {
                        throw Je(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[$a];
                        this.zn.le.add(n.bt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === Es) {
                    this.output(3, 5);
                } else if (t === Ss) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof uc) {
                    this.output(1, t.oe);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.Yn;
                        this.Yn = e;
                        this.writeObjectValue(t);
                        this.Yn = n;
                    }
                }
                break;

              default:
                throw Je(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (xs(t)) {
            const n = t[vs];
            this.output(38, [ oc(n), n.varProps, n.constProps, t[bs].ct ]);
        } else if (t instanceof Js) {
            const {O: n, et: e} = t.data;
            n === null ? this.output(e ? 42 : 43, 0) : this.output(39, [ n, e ]);
        } else if (t instanceof ls) {
            t.data === null ? this.output(44, [ t.consumer, t.property ]) : this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof Gu) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (Uu(t)) {
            const n = Fu(t);
            const e = Du(t);
            const s = n.h;
            const o = n.ct;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.zn.dt.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (Nu(t)) {
            const n = t[hf](t);
            if (Hi(n)) {
                const t = this.resolvePromise(n, (t, n) => new Zu(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.Yn.It;
                this.Yn = this.Yn.Yn;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        cf(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.zn.ue(t)) {
            this.zn.ce(t.fe, 16);
            this.output(11, t.fe.id);
        } else if (t instanceof hs) {
            if (t instanceof Ns) {
                const n = function e(t, n) {
                    if (n === os) {
                        return n;
                    }
                    return Yi(t.Ct.resolved || t.Ct.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && hf in n && (e = n[hf](n));
                        e === void 0 && (e = os);
                        return e;
                    });
                }(t, t.Nt);
                if (Hi(n)) {
                    const e = this.resolvePromise(n, (n, e) => new Zu(34, n, e, t.ct, t.Ct));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Ct, t.ct, n ]);
                }
                return;
            }
            if (t instanceof Hs) {
                this.output(31, [ ...Fn(this.zn, t), t.h, t.m, ...t.ct || [] ]);
            } else if (t instanceof ds) {
                let n = t.Nt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = cf(t.Nt);
                const i = t instanceof $s;
                const c = i && t.Pt !== 0 ? t.Pt : void 0;
                const l = i && t.Lt !== 1 ? t.Lt : void 0;
                const u = i && t.Dt !== 0 ? t.Dt : void 0;
                const f = i && t.h & -25 || void 0;
                o || r ? n = os : e ? n = t.Nt : s && (n = os);
                const a = [ t.Ct, t.ct ];
                if (i) {
                    a.push(t.$t, t.yt, t.Ot);
                    a.push(f || void 0);
                }
                n === os && c === void 0 && l === void 0 && u === void 0 || a.push(n === void 0 ? Qu : n);
                if (i) {
                    a.push(c);
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Nt;
                const e = [ n === void 0 ? Qu : n ];
                t.ct && e.push(...t.ct);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.zn.ae(t)) {
            const n = this.zn.St(t);
            this.zn.he(t, xi, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                tc(e, t => {
                    this.zn.St(t);
                });
                this.zn.ce(t, 16);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.zn.ce(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (Ks(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof ku) {
            const n = [ t.vt, t.h, t.It, t.ft ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (Hi(t)) {
            const n = this.resolvePromise(t, (t, n) => new Zu(24, t, n));
            this.output(2, n);
        } else if (t instanceof Zu) {
            if (t.de === 34) {
                if (t.vt) {
                    this.output(34, [ t.vt, t.ct, t.pe ]);
                } else {
                    if (!t.$e) {
                        console.error(t.pe);
                        throw Je(33);
                    }
                    {
                        const n = this.Yn.It;
                        this.Yn = this.Yn.Yn;
                        this.writeValue(t.pe, n);
                    }
                }
            } else {
                this.output(24, [ t.$e, t.pe ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof sc) {
            const n = t.ye;
            if (this.getSeenRefOrOutput(n, this.Yn.It, !0)) {
                let t = this.Jn.get(n);
                if (t === void 0) {
                    t = this.Qn++;
                    this.Jn.set(n, t);
                    this.Rt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else if (this.Zn && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.Zn && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.Zn && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.Zn && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.Zn && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.Zn && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.Zn && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.Zn && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else {
            if (!dl(t)) {
                throw Je(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Qn++;
        t.then(s => {
            this.Hn.delete(t);
            this.Rt[e] = this.zn.St(n(!0, s));
        }).catch(s => {
            this.Hn.delete(t);
            this.Rt[e] = this.zn.St(n(!1, s));
        });
        this.Hn.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.zn.me + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {se: n} = this.zn;
        for (;this.Bn < n.length || this.Hn.size; ) {
            let e = t > 0;
            for (;this.Bn < n.length; this.Bn++) {
                e ? this.Wt.write(Fr) : e = !0;
                this.writeValue(n[this.Bn], this.Bn);
                t++;
            }
            if (this.Hn.size) {
                try {
                    await Promise.race(this.Hn);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.Hn.size; ) {
            if (e < t.length) {
                n ? this.Wt.write(Fr) : n = !0;
                const s = t[e++];
                this.writeValue(this.zn.se[s], s);
                continue;
            }
            try {
                await Promise.race(this.Hn);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Rt.length - 1;
        for (;t >= 0 && this.Rt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Rt.length - 1 ? this.Rt : this.Rt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Wt.write(Or);
                this.writeRootRefPath(t);
                this.Wt.write(Or);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Wt.write(jr);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.zn.we = this.zn.se.length;
        this.zn.ve = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Wt.write(Fr);
            this.Wt.write(14 + Fr);
            this.outputForwardRefsArray(n);
        }
        this.Wt.write(Lr);
        this.zn.be = this.zn.se.length + (this.zn.ve ? 1 : 0);
        this.zn.te = e;
    }
}

class Zu {
    de;
    $e;
    pe;
    ct;
    vt;
    constructor(t, n, e, s, o) {
        this.de = t;
        this.$e = n;
        this.pe = e;
        this.ct = s;
        this.vt = o;
    }
}

const tc = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (nc(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === xi || t === Ni && (Nr(s) || ec(e, s))) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const nc = t => typeof t === "object" && t !== null && !Nr(t);

const ec = (t, n, e = !1) => {
    if (e || !Object.prototype.hasOwnProperty.call(t, ri)) {
        return !1;
    }
    const s = n[vs];
    return Nr(s.varProps) && !ic(n) && !rc(t[yi]);
};

const ic = t => !!t[bs].ct?.size;

const rc = t => t instanceof Map && t.has(":");

function Fn(t, n) {
    n.kt && n.kt[0] === "{" && (n.kt = `(${n.kt})`);
    const e = t.gt(n.kt, n.lt.length, n.ot);
    return [ e, n.lt ];
}

class sc {
    ye;
    constructor(t) {
        this.ye = t;
    }
}

const oc = t => new sc(t);

let lc = () => !1;

class uc {
    oe;
    constructor(t) {
        this.oe = t;
    }
}

class cc {
    NodeConstructor;
    DomRefConstructor;
    Et;
    he;
    dt;
    Wt;
    _e=new Map;
    ge=new Map;
    Ee=0;
    Se=[];
    se=[];
    ke=[];
    Re;
    me=0;
    be=0;
    te=0;
    we=0;
    ve=!1;
    Tt=new Set;
    xt=new Set;
    Mt=new Set;
    le=new Set;
    Pe;
    ce=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.Et = e;
        this.he = s;
        this.dt = o;
        this.Wt = r;
        this.Pe = new Ku(this);
    }
    async Xt() {
        await this.Pe.serialize();
    }
    async Te(t, n, e, s) {
        await this.Pe.serializePatch(t, n, e, s);
    }
    ne(t) {
        this.Wt = t;
        this.Pe.ne(t);
    }
    getSeenRef(t) {
        return this._e.get(t);
    }
    ie(t, n, e) {
        const s = {
            It: e,
            Yn: n
        };
        this._e.set(t, s);
        return s;
    }
    qe(t) {
        const n = [];
        for (;t.Yn; ) {
            n.unshift(t.It);
            t = t.Yn;
        }
        n.unshift(t.It);
        return n;
    }
    re(t, n, e) {
        const s = this.qe(t);
        const o = e === void 0;
        e === void 0 && (e = this.se.length);
        this.se[e] = new uc(s);
        o && (this.ke[e] = n);
        t.Yn = null;
        t.It = e;
        o && this.Re?.(e, this.se[e], n);
    }
    St(t, n = !1) {
        let e = this._e.get(t);
        let s;
        if (e) {
            e.Yn && this.re(e, t);
            s = e.It;
        } else {
            s = this.se.length;
            e = {
                It: s
            };
            this._e.set(t, e);
            this.se.push(t);
            this.ke.push(t);
            this.Re?.(s, t, t);
        }
        return n ? e : s;
    }
    ee(t) {
        const n = this.se.length;
        const e = {
            It: n
        };
        this._e.set(t, e);
        this.se.push(t);
        this.ke.push(t);
        this.Re?.(n, t, t);
        return e;
    }
    Ae(t, n) {
        const e = this.se.length;
        const s = {
            It: e
        };
        this._e.set(n, s);
        this.se.push(t);
        this.ke.push(n);
        return e;
    }
    ae(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    ue(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    Me(t) {
        const n = this._e.get(t);
        return n && (n.Yn ? void 0 : n.It);
    }
    gt(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.ge.get(t);
        if (o === void 0) {
            o = this.Ee + this.Se.length;
            this.ge.set(t, o);
            if (s) {
                this.Se.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.Se.push(e += ")=>" + t);
            }
        }
        return o;
    }
    xe(t, n) {
        this.Ee = t;
        if (n) {
            this.ge.clear();
            for (let t = 0; t < n.length; t++) {
                this.ge.set(n[t], t);
            }
        }
    }
}

const fc = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(Cr(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    lc = n ? t => t instanceof n : () => !1;
    return new cc(t, n, e, s, o, r);
};

const ac = (t, n) => t[n];

const hc = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        Uu(t) && (t = Du(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!hc(If(ac, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!hc(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Ru(t)) {
            return !0;
        }
        if (xs(t)) {
            return !0;
        }
        if (Hi(t)) {
            return !0;
        }
        if (Ks(t)) {
            return !0;
        }
        if (Nu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Js) {
            return !0;
        }
        if (lc?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (Ge(t) || ya(t) || t === bo || t === wo) {
            return !0;
        }
    } else if (t === gs || t === os || t === fs) {
        return !0;
    }
    return !1;
};

const dc = (t, n) => {
    let e = dl(t) ? En.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (ze(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let pc = !1;

const $c = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (pc = !0);
            const n = `{${ze(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${dc(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = mc(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${$c(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${yc(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = pc ? "" : `(${JSON.stringify(t).length} chars)`;
        pc = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const yc = t => Yu[t] || `Unknown(${t})`;

const mc = t => Ju[t] || `Unknown(${t})`;

function Dn(t, n, e, s = 0) {
    const o = Xn(t, n, s);
    for (;!o.next().done; ) {}
}

function* Xn(t, n, e = 0) {
    const s = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const o = t => t === 14;
    const r = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let i = e; i < t.length; i += 2) {
        s(t[i], t[i + 1]) ? r(i) : o(t[i]) && (n.Rt = t[i + 1]);
        yield;
    }
}

const wc = new WeakMap;

const vc = new Map;

const bc = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t._(e);

      case 2:
        const s = t.Ut(e);
        return s === -1 || s === void 0 ? gs : t._(s);

      case 14:
        return e;

      case 3:
        return Hu[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const s = e;
                const o = s.indexOf("#");
                const r = s.indexOf("#", o + 1);
                const i = +s.slice(0, o);
                const c = r === -1 ? +s.slice(o + 1) : +s.slice(o + 1, r);
                const l = i + c;
                const u = t._(i);
                const f = t._(l);
                n = jn(u, f, r !== -1 ? s : null, t);
            } else {
                n = jn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new ku(-1, -1, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return pa(null);

      case 30:
        return new hs(t, 0);

      case 31:
        return new Hs(t, null, null, null);

      case 32:
        return new ds(t, null);

      case 33:
        return new $s(t, null, void 0, {});

      case 34:
        return new Ns(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = bc(t, s, o);
            const i = zu(r, 0, t);
            Yc(s) && vc.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new Ys(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        wc.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        const l = e.length;
        const u = l >>> 2;
        const f = l & 3;
        const a = u * 3 + (f ? f - 1 : 0);
        return new Uint8Array(a);

      case 38:
        return w(null);

      case 10:
        return Wn(t, e);

      case 11:
        const h = Wn(t, e);
        if (dl(h)) {
            Yl(h);
            return yu(h);
        }
        throw Je(17, [ typeof h ]);

      case 39:
        return new Js({});

      case 42:
        return new Js({
            O: null,
            et: !0
        });

      case 43:
        return new Js({
            O: null,
            et: !1
        });

      case 40:
      case 44:
        return new ls(null, null, null, null);

      case 41:
        return new Gu;

      default:
        throw Je(18, [ n ]);
    }
};

function Wn(t, n) {
    return n ? t.rootVNode ? Tl(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const _c = (t, n, e) => {
    let s = null;
    let o = null;
    if (He(t)) {
        o = t;
    } else {
        if (!Qe(t)) {
            throw Je(7, [ t ]);
        }
        s = t;
    }
    return ea(s, n, null, o, e);
};

const gc = (t, n, e) => ea(null, n, t, null, e);

const Ec = (t, n) => ea(null, t, null, null, n);

const Sc = (t, n, e) => {
    const s = Ec(t, e);
    return s;
};

const kc = (t, n, e, s) => ea(t, e, null, n, s);

const Rc = (t, n, e, s, o) => {
    const r = kc(t, n, e, o);
    r.Ie(s);
    return r;
};

const Pc = (t, n, e, s) => {
    const o = _c(t, n, s);
    return o;
};

const Tc = (t, n, e, s) => {
    const o = gc(t, n, s);
    return o;
};

const qc = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const Ac = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Vn(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Mc = (t, n, e) => new Hs(null, t, n, e || null);

class xc {
    Ne;
    dt;
    Ce=null;
    Un=!1;
    tn;
    _;
    sn;
    Oe=0;
    zt=null;
    je=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.sn = t;
        this.tn = n;
        this.Ne = Dr;
        this.dt = new WeakMap;
        this._ = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return Of(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return fc(t, n, e, this.setHostProp.bind(this), this.dt, s);
    }
    ht() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const Ic = Symbol();

const cd = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[Ic] = t;
    return n;
};

class Nc {}

function Un(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function zn(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === Nc) {
                    const t = o.pop();
                    await n(() => o.push(t()));
                    continue;
                }
                if (typeof e === "function") {
                    if (e === Promise) {
                        o.push(await o.pop());
                    } else {
                        const n = e.apply(t);
                        Hi(n) && await n;
                    }
                    continue;
                }
                Bn(t, r, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                Hi(n) && await n;
            }
        }
    })();
}

function Bn(t, n, e, s) {
    if (e == null) {
        t.textNode("");
    } else if (typeof e === "boolean") {
        t.textNode("");
    } else if (typeof e === "number") {
        t.textNode(e + "");
    } else if (typeof e === "string") {
        t.textNode(e);
    } else if (typeof e === "object") {
        if (Array.isArray(e)) {
            for (let t = e.length - 1; t >= 0; t--) {
                n(e[t]);
            }
        } else if (Tu(e)) {
            (function s(t, n) {
                const e = n instanceof Hs ? n.rt() : n;
                if (e instanceof $s) {
                    const n = e.Pt;
                    if (n && !(e.h & 256)) {
                        t.St(e);
                        t.Tt.add(e);
                    }
                }
            })(t.serializationCtx, e);
            t.openFragment(Ss);
            const o = t.getOrCreateLastNode();
            const r = e instanceof Hs ? e.rt() : e;
            n(t.closeFragment);
            n(() => Of(r, o, ".", t));
            n(Nc);
        } else if (Hi(e)) {
            t.openFragment(Ss);
            n(t.closeFragment);
            n(e);
            n(Promise);
            n(() => t.streamHandler.flush());
        } else if (function o(t) {
            return !!t[Symbol.asyncIterator];
        }(e)) {
            n(async () => {
                for await (const n of e) {
                    await zn(t, n, {
                        currentStyleScoped: s.currentStyleScoped,
                        parentComponentFrame: s.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const o = e;
            const r = o.type;
            if (typeof r === "string") {
                (function e(t, n) {
                    const e = Ts(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(o, s.currentStyleScoped);
                let i = null;
                const c = t.openElement(r, o.key, o.varProps, o.constProps, s.currentStyleScoped, i, !!(o.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (r === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (r === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.qt) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = o.children;
                l != null && n(l);
            } else if (He(r)) {
                if (__EXPERIMENTAL__.suspense && (t => typeof t === "function" && Ic in t)(r)) {
                    n(() => (t => t[Ic])(r)(t, o, s, n));
                    return;
                }
                if (r === wo) {
                    const e = o.key != null ? {
                        [Ii]: o.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = o.children;
                    s != null && n(s);
                } else if (r === bo) {
                    const e = s.parentComponentFrame;
                    if (e) {
                        const r = e.componentNode.id || "";
                        const i = {};
                        const c = Ts(o, ki);
                        c && (i[ki] = c);
                        i["q:sparent"] = r;
                        t.openProjection(i);
                        const l = e.componentNode;
                        const u = t.getOrCreateLastNode();
                        const f = k(l, o, t);
                        i[li] = f;
                        n(Un(s, s.currentStyleScoped, s.parentComponentFrame));
                        n(t.closeProjection);
                        const a = o.children || null;
                        const h = e.consumeChildrenForSlot(u, f) || a;
                        a && h !== a && t.addUnclaimedProjection(e, "", a);
                        n(h);
                        n(Un(s, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = Ss;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (r === Eo) {
                    t.commentNode(Ts(o, "data") || "");
                } else if (r === ko) {
                    t.streamHandler.flush();
                    const e = o.children;
                    let r;
                    r = He(e) ? e({
                        async write(n) {
                            await zn(t, n, {
                                currentStyleScoped: s.currentStyleScoped,
                                parentComponentFrame: s.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : e;
                    n(r);
                    Hi(r) && n(Promise);
                } else if (r === go) {
                    t.htmlNode(Ts(o, "data"));
                } else if (r === So) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(o.children);
                } else if (ya(r)) {
                    const e = {};
                    t.openComponent(e);
                    const i = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(o.children, s.currentStyleScoped, s.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[$a];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(ri, o);
                        s.setProp(Ni, r);
                        n.key !== null && s.setProp(Ii, n.key);
                        return Go(t, s, s, o, r);
                    })(t, o, r);
                    n(Un(s, s.currentStyleScoped, s.parentComponentFrame));
                    n(() => t.closeComponent());
                    if (Hi(l)) {
                        n(async () => {
                            const t = await l;
                            const e = tr(i.getProp(pi));
                            n(t);
                            n(Un(s, e, c));
                        });
                    } else {
                        n(l);
                        const t = tr(i.getProp(pi));
                        n(Un(s, t, c));
                    }
                } else {
                    const e = {
                        [Ii]: o.key
                    };
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = t.getParentComponentFrame();
                    const i = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Go(t, o, n, e, s.props);
                    })(t, s && s.componentNode, r, o);
                    n(i);
                    Hi(i) && n(Promise);
                }
            }
        }
    }
}

const Cc = () => Yf;

const Oc = async t => {
    const [n, e] = Yf;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = xn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const jc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Xo();
    if (e) {
        return e;
    }
    const r = ea(null, "_rsc", Oc, null, [ t, {} ], o.$);
    const i = Os(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const Lc = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (Hi(t)) {
        return t.then(n, s);
    }
    const o = Fc(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return Hi(i) ? i.then(n, s) : n(i);
};

const Fc = t => t && t.__brand === "resource";

function Qn(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        n.bt.startsWith("_") || !Array.isArray(n.At) && !s || (n = ea(null, "_run", I, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = On(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            let c = 0;
            let l = 0;
            for (let t = 0; t <= o.length; t++) {
                if (t === o.length || o[t] === " ") {
                    if (t > l) {
                        const n = c + +o.slice(l, t);
                        if (l > 0) {
                            i.push(" ");
                            i.push({
                                id: n,
                                base: c
                            });
                        } else {
                            i.push(n);
                        }
                        c = n;
                    }
                    l = t + 1;
                }
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (Ge(o)) {
                i(c(o));
                Hn(t, n, o);
            } else if (o != null) {
                const e = Qn(t, n, o, s);
                e && i(e);
            }
        }
    } else if (Ge(r)) {
        o = c(r);
        Hn(t, n, r);
    }
    return o;
}

function Hn(t, n, e) {
    const s = rr(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.Mt.add(r);
        t.xt.add(e);
    }
}

const Dc = (t, n, e) => {
    Vc(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const Xc = (t, n, e) => {
    Vc(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const Wc = (t, n, e) => {
    Vc(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const Vc = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = Uc();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + ir(i), e, s);
            }
        } else {
            r(t + ir(n), e, s);
        }
    }
};

const Uc = () => {
    const t = Mf();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, Di);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, Di, s);
    }
    let o = t.$.getHostProp(e, Xi);
    o === null && (o = 0);
    t.$.setHostProp(e, Xi, o + 1);
    let r = t.$.getHostProp(e, Wi);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, Wi, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const zc = function(t, n) {
    const e = ge(n);
    return kf(e, () => {
        typeof this === "string" && Gf(Kf(e, this));
        const s = Yf?.[1];
        const o = s ?? n.getAttribute("data-qwik-inspector");
        if (!o || !t.detail.files.some(t => o.startsWith(t))) {
            return;
        }
        const r = Yf?.[0];
        if (!r || r.flags & 32) {
            return;
        }
        yn(e, r, 4);
        const i = n.ownerDocument;
        i.__hmrDone = i.__hmrT;
    });
};

let Bc;

function Jn(t) {
    const n = qf();
    if (!n) {
        return;
    }
    Bc ||= gc(zc, "_hmr");
    const e = n.m;
    const s = Bc.w([ e, t ]);
    Xc("qHmr", s);
}

function Yn(t, n, e, s, o) {
    const r = hl();
    _l(r, li, o);
    r.parent = n;
    _l(n, o, r);
    _l(r, ri, e);
    _l(r, Ni, s);
    r.dirty = 4;
    hn(t, r, 1);
    return r;
}

function Gn(t, n) {
    _l(t, si, n);
    t.flags |= 2048;
}

function Kn(t, n, e) {
    _l(n, Ni, e);
    yn(t, n, 4);
}

function Zn(t, n, e, s) {
    _l(n, s, null);
    const o = [];
    Et(t, o, e);
    Nl(o);
    if (e.flags & 2048) {
        const t = bl(e, si, null);
        t && t.replaceChildren();
        _l(e, si, null);
        e.flags &= -2049;
    }
}

let Qc = Promise.resolve();

const Hc = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const Jc = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !Hc.has(t));
};

function* te(t, n, e = Array(n.length / 2)) {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = yield* ee(t, n[s], n[s + 1]);
        yield;
    }
    return e;
}

function* ne(t, n, e = Array(n.length / 2)) {
    const s = n.length / 2;
    const o = new Uint8Array(s);
    const r = t._;
    const i = s => {
        if (!o[s]) {
            o[s] = 1;
            const r = s * 2;
            const i = n[r];
            const c = n[r + 1];
            e[s] = i === 0 ? c : bc(t, i, c);
        }
        return e[s];
    };
    t._ = t => i(typeof t === "string" ? parseInt(t, 10) : t);
    try {
        for (let t = 0; t < s; t++) {
            i(t);
            yield;
        }
        for (let o = 0; o < s; o++) {
            const s = o * 2;
            const r = n[s];
            const i = n[s + 1];
            const c = e[o];
            n[s] = 0;
            n[s + 1] = c;
            Yc(r) && (yield* ie(t, c, r, i));
            yield;
        }
    } finally {
        t._ = r;
    }
    return e;
}

function* ee(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = bc(t, n, e);
    Yc(n) && (yield* ie(t, s, n, e));
    return s;
}

function* ie(t, n, e, s) {
    if (e === 0) {
        return;
    }
    e !== 4 && Array.isArray(s) && (s = yield* te(t, s));
    switch (e) {
      case 4:
        yield* te(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!Jc(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
                yield;
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = wc.get(t);
            e ? r(o) : i(o);
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                n[t[e]] = t[e + 1];
                yield;
            }
            break;
        }

      case 28:
        {
            const t = n;
            const e = s;
            t.vt = e[0];
            t.h = e[1];
            t.It = e[2];
            t.ft = e[3];
            break;
        }

      case 29:
        n[$a][0] = s[0];
        break;

      case 30:
        {
            const t = n;
            const e = s;
            t.Nt = e[0];
            t.ct = new Set(e.slice(1));
            se(t.ct, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ot = t.getSyncFn(o[0]);
            e.lt = o[1];
            e.Nt = os;
            e.h = o[2];
            e.h |= 1;
            e.m = o[3];
            e.ct = new Set(o.slice(4));
            (function r(t) {
                if (t.m !== null && dl(t.m)) {
                    const n = t.m;
                    const e = t.ct;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (Qe(e)) {
                                const o = bl(n, e, null);
                                if (o !== null) {
                                    t.Nt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Jl(n);
                        e && n.firstChild === n.lastChild && ml(e) && (t.Nt = Ql(e));
                    }
                }
            })(e);
            se(e.ct, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Ct = e[0];
            e[1] && (t.ct = new Set(e[1]));
            e[2] && (t.$t = new Set(e[2]));
            e[3] && (t.yt = new Set(e[3]));
            e[4] && (t.Ot = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.jt = !0);
            const o = e.length > 6;
            o && (t.Nt = e[6]);
            t.Nt === os && (t.h |= 1);
            const r = e[7] ?? 0;
            t.expires = Math.abs(r);
            r < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.Lt = e[8] ?? 1;
                t.Ft = [];
            }
            t.Dt = e[9] ?? 0;
            se(t.ct, t);
            se(t.$t, t);
            se(t.yt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.Ct = r[0];
            const i = o.Ct.resolve(t).catch(() => {});
            Qc = Qc.finally(() => i);
            r[1] && (o.ct = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Nt = r[2]);
            e !== 34 && o.Nt !== os && (o.h &= -2);
            se(o.ct, o);
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 38:
        {
            const t = n;
            const e = s;
            let o = e[0];
            if (o === gs) {
                o = new Ys(wo, e[1], e[2], null, 0, null);
                o._proxy = t;
            }
            t[vs] = o;
            const r = t[bs];
            r.ct = e[3];
            oe(r.ct, t);
            break;
        }

      case 39:
        {
            const t = n;
            t.data.O = s[0];
            t.data.et = s[1];
            break;
        }

      case 42:
      case 43:
        break;

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            re(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      case 44:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = null;
            re(t);
            break;
        }

      case 27:
        {
            const t = n;
            const e = atob(s);
            for (let n = 0; n < e.length; n++) {
                t[n] = e.charCodeAt(n);
                (n & 31) === 31 && (yield);
            }
            break;
        }

      case 35:
        {
            const e = Vu(n);
            const o = vc.get(e);
            if (o) {
                vc.delete(e);
                yield* ie(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Fu(n);
            c.h = r;
            c.ct = i;
            oe(c.ct, e);
            break;
        }

      default:
        throw Je(16, [ e ]);
    }
}

function re(t) {
    const n = Ne;
    const e = t.consumer;
    if (n && !e) {
        return;
    }
    e[Wr] ||= new Map;
    e[Wr].set(t.property, t);
}

function se(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function oe(t, n) {
    if (t) {
        for (const [, e] of t) {
            se(e, n);
        }
    }
}

const Yc = t => t >= 23 || t === 4 || t === 5;

const Gc = new WeakMap;

const Kc = Symbol();

const Zc = (t, n) => {
    if (!Array.isArray(n) || dl(n) || (t => ze(t) && Kc in t)(n)) {
        return n;
    }
    let e = Gc.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new tf(t, n));
        Gc.set(n, e);
    }
    return e;
};

class tf {
    $;
    Le;
    constructor(t, n) {
        this.$ = t;
        this.Le = n;
    }
    get(t, n, e) {
        if (n === Kc) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.Le.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.Le[o];
        const i = this.Le[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = bc(c, r, i);
        Reflect.set(t, n, l);
        this.Le[o] = 0;
        this.Le[o + 1] = l;
        Yc(r) && ((t, n, e, s) => {
            const o = ie(t, n, e, s);
            for (;!o.next().done; ) {}
        })(c, l, r, i);
        return l;
    }
    has(t, n) {
        if (n === Kc) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === Kc) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.Le.length / 2) {
            return o;
        }
        const i = r * 2;
        this.Le[i] = 0;
        this.Le[i + 1] = e;
        return !0;
    }
}

const nf = t => {
    if (!t.Fe) {
        t.Fe = !0;
        t.De();
    }
};

const ef = (t, n, e) => {
    const s = {
        Xe: t,
        De: void 0,
        Fe: !1
    };
    const o = ar(() => {
        ((t, n, e) => {
            t.Fe = !1;
            const s = performance.now() + 10;
            let o = 0;
            try {
                for (;;) {
                    const e = t.Xe.next();
                    if (e.done) {
                        n(e.value);
                        return;
                    }
                    if ((31 & ++o) === 0 && performance.now() >= s) {
                        nf(t);
                        return;
                    }
                }
            } catch (t) {
                e(t);
            }
        })(s, t => {
            o.ln?.();
            n(t);
        }, t => {
            o.ln?.();
            e(t);
        });
    });
    s.De = o;
    return s;
};

async function le(t) {
    const n = fc(null, null, () => "", () => {}, new WeakMap);
    n.St(t);
    await n.Xt();
    return n.Wt.toString();
}

async function ue(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Array(n.length / 2);
    const s = ae(n, () => e);
    s.Vt = e;
    await rf(ne(s, n, e));
    return e[0];
}

const rf = t => new Promise((n, e) => {
    const s = ef(t, n, e);
    nf(s);
});

function ce(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function fe(t) {
    let n;
    const e = ae(t, () => n);
    n = Zc(e, t);
    e.Vt = n;
    return e;
}

function ae(t, n) {
    const e = {
        _: t => ce(t, n()),
        Ut: t => e.Rt?.[+t],
        getSyncFn: () => () => {},
        dt: new WeakMap,
        element: null,
        Rt: null
    };
    Dn(t, e);
    return e;
}

const sf = (t, n) => {
    const e = new WeakSet;
    return If(of, t, e, "_", n);
};

const of = (t, n, e, s) => {
    const o = Vu(t);
    if (o == null) {
        return t;
    }
    if (uf(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (Tu(o)) {
            return t;
        }
        if (hc(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (Hi(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (Be(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw Je(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw Je(3, [ o ]);
                    }
                    of(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof Hr) {
                return t;
            }
            if (Ue(o)) {
                for (const [t, s] of Object.entries(o)) {
                    of(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw Je(3, [ i ]);
    }
    return t;
};

const lf = /*#__PURE__*/ new WeakSet;

const uf = t => {
    if (ze(t) || He(t)) {
        return !lf.has(t) && !(af in t);
    }
    return !0;
};

const cf = t => !!t && (ze(t) || typeof t === "function") && (lf.has(t) || af in t);

const ff = t => {
    (ze(t) && t !== null || typeof t === "function") && lf.add(t);
    return t;
};

const af = Symbol();

const hf = Symbol();

const df = t => /*#__PURE__*/ Object.freeze({
    id: ir(t)
});

const pf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Xo();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o.m, t, n);
    s(1);
};

const $f = (t, n) => {
    const {val: e, set: s, iCtx: o} = Xo();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o.m, t);
    if (typeof n === "function") {
        return s(Te(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw Je(8, [ t.id ]);
};

const yf = t => {
    const n = Af();
    const e = n.m;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const mf = /*#__PURE__*/ df("qk-error");

const ld = (t, n = t => t.boundary.pending.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const ud = new WeakMap;

class fd {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = ad(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return ld(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const ad = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const hd = () => {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    const t = qf()?.$;
    return t?.outOfOrderStreaming === !0 && !rd(t);
};

const wf = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && Iu(t, n, r);
};

const vf = new WeakMap;

function* he(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`script[type="qwik/state"][q\\:instance="${e.zt}"]${ci}`);
    const o = bf(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(fi) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        yield* de(t, e, i.textContent);
        yield;
    }
}

const bf = t => {
    let n = vf.get(t);
    if (!n) {
        n = new WeakSet;
        vf.set(t, n);
    }
    return n;
};

function* de(t, n, e) {
    if (!e) {
        return;
    }
    const [s, o, r, i] = JSON.parse(e);
    yield* function* c(t, n, e, s) {
        const o = n.Bt.length / 2;
        if (e !== o) {
            return;
        }
        for (let t = 0; t < s.length; t++) {
            n.Bt[e * 2 + t] = s[t];
            yield;
        }
        yield* Xn(n.Bt, t, e * 2);
        n.Qt = Zc(t, n.Bt);
        n.Qt.length = n.Bt.length / 2;
        n.Ht = n.Rt;
    }(t, n, s, o);
    _f(n, r || void 0);
    ((t, n) => {
        if (!__EXPERIMENTAL__.suspense || !n) {
            return;
        }
        for (let e = 0; e < n.length; e++) {
            const s = n[e];
            const o = t._(s.rootId);
            const r = s.subscriptions;
            if (o instanceof hs) {
                r instanceof Set && wf(t, o, o, o.ct ||= new Set, r);
            } else {
                if (!(r instanceof Map)) {
                    continue;
                }
                const n = Fu(o);
                const e = Du(o);
                if (!n || !e) {
                    continue;
                }
                const s = n.ct ||= new Map;
                for (const [o, i] of r) {
                    let r = s.get(o);
                    if (!r) {
                        r = new Set;
                        s.set(o, r);
                    }
                    wf(t, n, e, r, i);
                }
            }
        }
    })(t, i === void 0 ? void 0 : n._(i));
}

const _f = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.Ht ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Rt = e;
};

const gf = (t, n) => {
    const e = t;
    e.qVNodeDataReady ? n() : (e.qVNodeDataCallbacks ||= []).push(n);
};

function pe(t, n) {
    const e = t.qVNodeDataState ||= {
        Jt: [],
        Yt: null
    };
    t.qProcessVNodeDataPatch ||= n => pe(t, me(t, n));
    t.qVNodeDataReady = !1;
    e.Jt.push(n);
    $e(t, e);
}

function $e(t, n) {
    if (n.Yt) {
        return;
    }
    const e = n.Jt.shift();
    if (!e) {
        ye(t);
        return;
    }
    n.Yt = ef(function* s(t, n, e) {
        for (;t.qVNodeDataState === n; ) {
            if (e.next().done) {
                return;
            }
            yield;
        }
    }(t, n, e), () => {
        if (t.qVNodeDataState === n) {
            n.Yt = null;
            $e(t, n);
        }
    }, e => {
        n.Yt = null;
        Le(e);
        ye(t);
    });
    nf(n.Yt);
}

function ye(t) {
    if (t.qVNodeDataReady) {
        return;
    }
    t.qVNodeDataReady = !0;
    t.qVNodeDataState = void 0;
    const n = t.qVNodeDataCallbacks;
    t.qVNodeDataCallbacks = void 0;
    if (n) {
        for (let t = 0; t < n.length; t++) {
            n[t]();
        }
    }
}

function* me(t, n) {
    const e = n?.closest("[q\\:container]");
    const s = n?.getAttribute("q:r");
    const o = e && (s ? e.querySelector(`[q\\:rp="${s}"]`) : e);
    e && o && (yield* we(t, s || void 0, e, o, n.textContent));
}

function* we(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const m = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const w = function*(t) {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                yield;
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.suspense && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
            yield;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && (yield* w(s));
            yield;
        }
    };
    const b = t => {
        const n = m.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.suspense && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const v = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const _ = function*(n, e, s, o, r, i, c, l) {
        const u = __EXPERIMENTAL__.suspense && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let m = 0;
        let w = 0;
        let g = -1;
        let S = null;
        const k = () => {
            let t = 0;
            for (;Ef(w = r.charCodeAt(y)); ) {
                t += 1 << w - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        if (!s) {
            return;
        }
        do {
            if (s === o) {
                return;
            }
            S = null;
            const R = s == e ? 2 : b(s);
            if (R === 3) {
                const t = s;
                let e = s;
                for (;e && !(S = v(e)); ) {
                    e = e.parentNode;
                }
                yield* _(n, t, s, S, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (R === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (R === 64) {
                S = s;
                let t;
                do {
                    S = n.nextNode();
                    if (!S) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(S);
                } while (t !== 32 && t !== 65);
                S = null;
            } else if (R === 9) {
                S = s;
                do {
                    S = v(S);
                    if (!S) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(S) !== 8);
                yield* _(n, s, s, S, "", null, c);
            } else if (R === 6) {
                S = v(s);
                const n = s;
                const e = n?.shadowRoot;
                e && (yield* _(t.createTreeWalker(e, 129), null, e, null, "", null, null));
            }
            if ((R & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = m;
                    if (y < f) {
                        p += k();
                        if (w === 126) {
                            g = p;
                            y++;
                            w = y < f ? r.charCodeAt(m) : 33;
                        }
                        m = Sf(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.suspense && !u && R === 130 ? $.call(s, a) : null;
                if (h === p) {
                    g !== h || u && s === e || i.set(u ? ii(l, h) : h, s);
                    const t = r.substring(y, m);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== ei || n.charCodeAt(1) !== ei || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.suspense && t !== null) {
                    yield* E(c, s, t);
                    S = v(s);
                    S && (n.currentNode = S);
                }
            }
            yield;
        } while (s = S || n.nextNode());
    };
    const g = function*(n, e, s, o) {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        yield* _(r, e, e, v(e), s, n.qVNodeRefs, n, o);
    };
    const E = function*(t, n, e, s) {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && (yield* g(t, n, s, e));
    };
    if (e && s && o !== void 0) {
        e.qVNodeRefs ||= new Map;
        __EXPERIMENTAL__.suspense && n !== void 0 ? yield* E(e, s, n, o) : yield* g(e, s, o);
        return;
    }
    yield* w(t);
    const S = t.createTreeWalker(t, 129);
    yield* _(S, null, S.firstChild(), null, "", null, null);
}

const Ef = t => 33 <= t && t <= 46;

const Sf = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Ef(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function ve(t) {
    return t.Gt === 3;
}

function be(t, n) {
    const e = t.Kt ||= {
        Jt: [],
        Yt: null
    };
    t.Gt = 2;
    e.Jt.push(n);
    _e(t, e);
}

const kf = (t, n) => {
    const e = t;
    if (ve(e) && e.document.qVNodeDataReady) {
        return n();
    }
    return new Promise((t, s) => {
        ((t, n) => {
            const e = t;
            const s = () => {
                if (!ve(e)) {
                    (e.Zt ||= []).push(s);
                    return;
                }
                gf(e.document, () => {
                    ve(e) ? n() : s();
                });
            };
            s();
        })(e, () => {
            try {
                t(n());
            } catch (t) {
                s(t);
            }
        });
    });
};

function _e(t, n) {
    if (n.Yt) {
        return;
    }
    const e = n.Jt.shift();
    if (!e) {
        (function n(t) {
            const n = t.Gt;
            if (n !== 2) {
                return;
            }
            t.Gt = 3;
            t.Kt = void 0;
            const e = t.Zt;
            t.Zt = void 0;
            if (e) {
                for (let t = 0; t < e.length; t++) {
                    e[t]();
                }
            }
        })(t);
        return;
    }
    n.Yt = ef(e, () => {
        n.Yt = null;
        _e(t, n);
    }, () => {
        n.Yt = null;
        t.Gt = 3;
    });
    nf(n.Yt);
}

function ge(t) {
    const n = Se(t);
    if (!n) {
        throw Je(24);
    }
    return Ee(n);
}

function Ee(t) {
    const n = t;
    return n.qContainer ||= new Rf(n);
}

function Se(t) {
    return t.closest(Pi);
}

function ke(t, n) {
    const e = t + "";
    const s = n?.closest(Pi);
    const o = s?.qContainer;
    if (o) {
        const t = o.element.ownerDocument;
        (function s(t, n, e) {
            if (!__EXPERIMENTAL__.suspense || !e) {
                return;
            }
            const s = e.closest("[q\\:container]");
            if (!s) {
                return;
            }
            const o = s.querySelector(`script[type="qwik/vnode"][q\\:r="${n}"]:not([q\\:patch])`);
            const r = s.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${n}"][q\\:patch]`);
            pe(t, function* i(t, n, e, s, o, r) {
                yield* we(t, n, e, s, o);
                for (let n = 0; n < r.length; n++) {
                    yield* me(t, r[n]);
                }
            }(t, n, s, e, o?.textContent || void 0, r));
        })(t, e, n);
        gf(t, () => {
            o.element.qContainer === o && be(o, he(o, e));
        });
    }
}

class Rf extends xc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    dt=new WeakMap;
    We;
    zt;
    Rt=null;
    vNodeLocate=t => Tl(this.rootVNode, t);
    Gt=0;
    Zt=void 0;
    Kt=void 0;
    Bt;
    Qt;
    Ht=null;
    Ve=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(Ei);
        if (!this.qContainer) {
            throw Je(25);
        }
        const n = t.ownerDocument;
        this.document = n;
        this.element = t;
        this.je = t.getAttribute(wi);
        this.zt = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = fl(this.element);
        this.Bt = [];
        this.Qt = [];
        __EXPERIMENTAL__.suspense && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= ke);
        this.We = mi(n, this.zt) || Es;
        this.Ue();
        t.qContainer = this;
        t.qDestroy = () => this.ln();
        this.Gt = 1;
        (function e(t) {
            const n = t;
            if (n.qVNodeDataStarted || n.qVNodeDataProcessed) {
                return;
            }
            n.qVNodeDataStarted = !0;
            n.qVNodeData ||= new WeakMap;
            pe(n, function* e(t) {
                yield* we(t);
                t.qVNodeDataProcessed = !0;
            }(t));
        })(n);
        gf(n, () => {
            this.Gt === 1 && be(this, this.ze());
        });
    }
    * ze() {
        const t = this.element;
        if (t.qContainer !== this) {
            return;
        }
        const n = t.querySelector(`script[type="qwik/state"][q\\:instance="${this.zt}"]:not(${ci})`) || t.querySelector(`script[type="qwik/state"]:not([q\\:instance]):not(${ci})`);
        if (n) {
            this.Bt = JSON.parse(n.textContent);
            yield* Xn(this.Bt, this);
            this.Ht = this.Rt;
            const e = this.Bt.length / 2;
            const s = t.getAttribute("q:prewarm");
            this.Qt = s !== null && e > 0 && e >= +s ? yield* ne(this, this.Bt) : Zc(this, this.Bt);
        }
        __EXPERIMENTAL__.suspense && (yield* he(this));
        this.Be();
        t.setAttribute(Ei, "resumed");
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    ln() {
        this.vNodeLocate = () => null;
        this.Bt.length = 0;
        this.Qt.length = 0;
        this._ = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.suspense && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(Ei);
        const n = t.ownerDocument;
        this.Kt = void 0;
        this.Gt = 0;
        const e = n.querySelector(Pi) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataStarted = void 0;
            n.qVNodeDataReady = void 0;
            n.qVNodeDataState = void 0;
            n.qVNodeDataCallbacks = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.suspense && (e || (n.qProcessOOOS = void 0));
    }
    Be() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(di);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Xn(t, n) {
        this.Qt[t] = n;
    }
    parseQRL(t) {
        const n = Ln(t, this);
        return n;
    }
    handleError(t, n) {
        const e = n && this.resolveContext(n, mf);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, $i);
        s == null && this.setHostProp(t, $i, s = []);
        Xe(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, $i);
            if (e != null && Ve(e, n.id, 0)) {
                return We(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (wl(n)) {
                if (bl(n, ri, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        _l(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case Ci:
          case Ni:
          case ri:
          case $i:
          case yi:
          case ki:
            s = this._;
            break;

          case Oi:
          case Xi:
            s = parseInt;
            break;
        }
        return bl(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    _=t => ce(t, this.Qt);
    Ut(t) {
        return this.Ht?.[t];
    }
    getSyncFn(t) {
        const n = this.We[t];
        return n;
    }
    Qe(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, pi);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, pi, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.Ve == null) {
            this.Ve = new Set;
            const t = this.document.querySelectorAll(hi);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.Ve.add(e.getAttribute(ai));
            }
        }
        if (!this.Ve.has(n)) {
            this.Ve.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(ai, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Ue() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === Ui) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.sn = {
            containerAttributes: t
        };
    }
}

let Pf;

let dd;

if (Ne) {
    const t = Ac();
    t && (dd = new t);
}

function Re(t) {
    if (dd) {
        const t = dd.getStore();
        if (t) {
            return t;
        }
    }
    if (Pf === void 0) {
        const n = qf();
        if (n && n.tn) {
            return n.tn;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return Pf;
}

function Pe(t, n) {
    if (dd) {
        return dd.run(t, n);
    }
    const e = Pf;
    try {
        Pf = t;
        return n();
    } finally {
        Pf = e;
    }
}

let Tf;

const qf = () => Tf;

const Af = () => {
    const t = qf();
    if (!t) {
        throw Je(9);
    }
    return t;
};

const Mf = () => {
    const t = qf();
    if (!t || t.nn !== Mi) {
        throw Je(10);
    }
    return t;
};

function Te(t, n, ...e) {
    return qe.call(this, t, n, e);
}

function qe(t, n, e) {
    const s = Tf;
    try {
        Tf = t;
        return n.apply(this, e);
    } finally {
        Tf = s;
    }
}

const xf = (t, n, e = ge(n)) => {
    const s = Tl(e.rootVNode, n);
    const o = e.tn;
    o && function r(t) {
        if (dd) {
            dd.enterWith(t);
            return;
        }
        Pf = t;
    }(o);
    const i = Me(o, s, t);
    i.$ = e;
    return i;
};

function Ae(t, n, e) {
    const s = {
        m: n,
        nn: Mi,
        en: void 0,
        tn: t,
        $: e,
        rn: void 0
    };
    return s;
}

function Me(t, n, e) {
    const s = t || (e && ze(e) && "locale" in e ? e.locale : void 0);
    const o = {
        m: n,
        nn: e,
        en: void 0,
        tn: s,
        $: void 0
    };
    return o;
}

const If = (t, ...n) => {
    if (typeof t === "function") {
        if (!Tf) {
            return t(...n);
        }
        {
            const e = Tf.en;
            try {
                Tf.en = void 0;
                return t(...n);
            } finally {
                Tf.en = e;
            }
        }
    }
    if (Tu(t)) {
        return t.untrackedValue;
    }
    return Vu(t);
};

const Nf = /*#__PURE__*/ Ae(void 0, void 0, void 0);

const Cf = (t, n, e, s, o) => {
    const r = Nf.en;
    const i = Nf.$;
    try {
        Nf.en = m(n, e, o);
        Nf.$ = s;
        return qe(Nf, t);
    } finally {
        Nf.en = r;
        Nf.$ = i;
    }
};

const Of = (t, n, e, s, o) => {
    t instanceof Hs && t.m !== n && n && (t.m = n);
    return Cf(() => t.value, n, e, s, o);
};

const jf = () => qf()?.m;

const Lf = () => {
    const t = qf();
    if (t) {
        return t.nn;
    }
};

const Ff = () => {
    const t = qf();
    if (t) {
        return t.$;
    }
};

const Df = t => t;

const Xf = t => t.l || Promise.resolve();

let Wf = (t, n, e, s, o) => new Vf(t, n, e, s, o);

class Vf {
    _t;
    bt;
    He;
    Je;
    $;
    constructor(t, n, e, s, o) {
        this._t = t;
        this.bt = n;
        this.He = e;
        this.Je = s;
        s && this.Ye(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        Ce && t && Ie(t, .8);
    }
    get st() {
        return td(this.bt);
    }
    Ye(t) {
        this.Je = t;
        Hi(t) && t.then(t => this.Je = t, t => {
            console.error(`qrl ${this.bt} failed to load`, t);
            this.Je = null;
        });
    }
    Ge() {
        if (this.Je != null) {
            return this.Je;
        }
        if (this._t === "") {
            const t = this.$.zt;
            const n = this.$.element?.ownerDocument || document;
            const e = mi(n, t);
            return this.Je = e[+this.bt];
        }
        Ce && this._t && Ie(this._t, 1);
        const t = this.bt;
        const n = this.He ? this.He().then(n => n[t]) : yr().importSymbol(this.$?.element, this._t, t);
        this.Ye(n);
        return this.Je;
    }
}

Ce && import.meta.hot && (t => {
    if (!Ce || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        Wf = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t._t;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t._t;
            if (i) {
                t._t = e(i, o);
                r = !0;
            }
            const c = t.He?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.He = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.bt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.bt}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.Je = void 0;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    }, !0);
})(Vf);

const Uf = Symbol();

const zf = t => t?.[Uf] ?? t;

class Bf {
    Ke;
    resolved=void 0;
    At;
    $;
    constructor(t, n, e) {
        this.Ke = t;
        if (n) {
            this.At = n;
            typeof n === "string" && (this.$ = e);
        }
        t.Je == null || this.At && typeof this.At === "string" || Hi(t.Je) || (this.resolved = ta(this, t.Je));
    }
}

const Qf = function(t, ...n) {
    const e = zf(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = qf();
    return Hf.call(e, s?.$).then(() => qe.call(t, s, e.resolved, n));
};

const Hf = async function(t) {
    const n = zf(this);
    return Yi(na(n, t), () => n.resolved);
};

const Jf = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[Uf].resolved;
        },
        set(t) {
            this[Uf].resolved = t;
        }
    },
    At: {
        get() {
            return this[Uf].At;
        },
        set(t) {
            this[Uf].At = t;
        }
    },
    $: {
        get() {
            return this[Uf].$;
        },
        set(t) {
            this[Uf].$ = t;
        }
    },
    Ke: {
        get() {
            return this[Uf].Ke;
        }
    },
    _t: {
        get() {
            return this[Uf].Ke._t;
        }
    },
    bt: {
        get() {
            return this[Uf].Ke.bt;
        }
    },
    st: {
        get() {
            return this[Uf].Ke.st;
        }
    },
    dev: {
        get() {
            return this[Uf].Ke.dev;
        }
    },
    Ze: {
        value: Qf
    },
    w: {
        value: function(t) {
            const n = zf(this);
            const e = new Bf(n.Ke, t, n.At ? n.$ : void 0);
            return ia(e);
        }
    },
    s: {
        value: function(t) {
            const n = zf(this);
            n.Ke.Ye(t);
            n.resolved = ta(n, t);
        }
    },
    resolve: {
        value: Hf
    },
    getSymbol: {
        value: function() {
            return zf(this).Ke.bt;
        }
    },
    getHash: {
        value: function() {
            return zf(this).Ke.st;
        }
    },
    getCaptured: {
        value: function() {
            const t = zf(this);
            Zf(t);
            return t.At;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = zf(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Hf.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return qe(t, e.resolved, o);
            };
            return s;
        }
    }
});

let Yf = null;

const Gf = t => {
    Yf = t;
};

const Kf = (t, n, e = 0, s) => {
    const o = [];
    let r = s;
    let i = e;
    for (let s = e; s <= n.length; s++) {
        if (s === n.length || n.charCodeAt(s) === 32) {
            if (s > i) {
                const e = +n.slice(i, s);
                r = r === void 0 ? e : r + e;
                o.push(t._(r));
            }
            i = s + 1;
        }
    }
    return o;
};

const Zf = t => {
    const n = t.At;
    const e = t.$;
    if (typeof n === "string") {
        if (!e) {
            throw Je(13);
        }
        const s = Qc;
        Yf = t.At = ((t, n) => {
            const e = n.indexOf("#");
            if (e === -1) {
                return Kf(t, n);
            }
            const s = n.indexOf("#", e + 1);
            const o = +n.slice(0, e) + +n.slice(e + 1, s);
            return Kf(t, n, s + 1, o);
        })(e, n);
        if (Qc !== s) {
            return Qc;
        }
    } else {
        Yf = n || null;
    }
};

const ta = (t, n) => {
    if (typeof n !== "function" || !t.At) {
        return n;
    }
    return function e(...s) {
        Zf(t);
        return n.apply(this, s);
    };
};

const na = (t, n) => {
    const e = t.Ke;
    const s = typeof t.At === "string";
    s && !t.$ && (t.$ = n || qf()?.$);
    if (t.resolved) {
        return;
    }
    const o = la();
    const r = qf();
    const i = e.Ge();
    const c = Yi(i, n => {
        t.resolved = ta(t, n);
    });
    if (c) {
        const t = e.bt;
        sa(t, r?.m instanceof Yr ? r?.m.node : void 0, o);
    }
    const l = s && t.$ && Zf(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const ea = (t, n, e, s, o, r) => {
    const i = Wf(t, n, s, e, r);
    const c = new Bf(i, o, r);
    return ia(c);
};

const ia = t => {
    const n = async function(...t) {
        return Qf.call(n, this, ...t);
    };
    n[Uf] = t;
    Object.setPrototypeOf(n, Jf);
    return n;
};

const ra = /*#__PURE__*/ new Set;

const sa = (t, n, e) => {
    if (!ra.has(t)) {
        ra.add(t);
        oa("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const oa = (t, n) => {
    ed() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const la = () => {
    if (ed()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let ua = 0;

const ca = t => ea(null, "s" + ua++, t, null, null);

const fa = ca;

const aa = t => t;

const ha = t => ea("", Ye, t, null, null);

const da = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return ea("", Ye, t, null, null);
};

const pa = t => {
    function n(n, e, s = 0) {
        const o = t.st.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[$a] = [ t ];
        return co(i, n, null, n.children, s, r);
    }
    n[$a] = [ t ];
    return n;
};

const $a = Symbol();

const ya = t => typeof t == "function" && t[$a] !== void 0;

const ma = t => pa(fa(t));

const wa = Is(aa);

const va = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const ba = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !Xr(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(Ei, "resumed");
    const s = ge(t);
    s.sn = e.serverData || {};
    const o = s.rootVNode;
    _l(o, es, n);
    yn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            Et(s, [], s.rootVNode);
        }
    };
};

const _a = (t, n) => {
    const {val: e, set: s, iCtx: o} = Xo();
    if (e != null) {
        return e;
    }
    const r = He(t) ? Te(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = zu(r, i, t);
        s(c);
        return c;
    }
};

const ga = () => {
    const {val: t, set: n, iCtx: e} = Xo();
    if (t != null) {
        return t;
    }
    const s = e.$.je || "";
    const o = s ? or(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e.m, ri);
    const i = r?.getHash().substring(0, 3) || "";
    const c = (t => {
        const n = (t => {
            const n = t.Ce;
            return n || t;
        })(t);
        return (t => t.toString(36))(n.Oe++);
    })(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function xe(t, n) {
    const e = qf();
    return e?.$?.sn[t] ?? n;
}

const Ea = /*#__PURE__*/ new Map;

const Sa = (t, n) => {
    let e = Ea.get(n);
    e || Ea.set(n, e = ka(t, n));
    return e;
};

const ka = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = Aa;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === ih) {
            r++;
            e = th;
        }
        const s = ah[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, m] = p;
            if (($ === l || $ === Fa || $ === Da && Ra(l) || $ === Wa && qa(l)) && (y === e || y === Fa || y === Da && Ra(e) || y === Xa && !Ra(e) && e !== Ya || y === Wa && qa(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (m === ja || m == La) {
                    if (m === La) {
                        if (c !== Ma || h()) {
                            if (!Pa(e)) {
                                const t = y == Xa ? 1 : y == Ha ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            Pa(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === Xa) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || Aa;
                        if (c === xa) {
                            u(r - 1);
                            i++;
                        }
                    } while (Ta(c));
                } else {
                    o.push(c);
                    if (c === xa && m === Aa) {
                        u(r - 8);
                        i = r;
                    } else {
                        m === Ia && f(n);
                    }
                    c = m;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === xa || h()) {
            return;
        }
        u(t);
        s.push(".", oi, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === Ja) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === Ja) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | sh) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(xa) !== -1 || o.indexOf(Na) !== -1;
    }
};

const Ra = t => t >= Ga && t <= Ka || t >= th && t <= nh || t >= oh && t <= lh || t >= 128 || t === rh || t === Ja;

const Pa = t => t === Za || t === Ya || t === eh || t === Qa || Ra(t);

const Ta = t => t === Ca || t === Na || t === Oa || t === xa;

const qa = t => t === Ba || t === Va || t === Ua || t === za;

const Aa = 0;

const Ma = 2;

const xa = 5;

const Ia = 6;

const Na = 10;

const Ca = 11;

const Oa = 12;

const ja = 17;

const La = 18;

const Fa = 0;

const Da = 1;

const Xa = 2;

const Wa = 3;

const Va = 9;

const Ua = 10;

const za = 13;

const Ba = 32;

const Qa = 35;

const Ha = 41;

const Ja = 45;

const Ya = 46;

const Ga = 48;

const Ka = 57;

const Za = 58;

const th = 65;

const nh = 90;

const eh = 91;

const ih = 92;

const rh = 95;

const sh = 32;

const oh = 97;

const lh = 122;

const uh = 123;

const ch = 125;

const fh = /*@__PURE__*/ (() => [ [ Fa, 39, 14 ], [ Fa, 34, 15 ], [ Fa, 47, 16, "*" ] ])();

const ah = /*@__PURE__*/ (() => [ [ [ Fa, 42, Ma ], [ Fa, eh, 7 ], [ Fa, Za, Ia, ":", "before", "after", "first-letter", "first-line" ], [ Fa, Za, xa, "global" ], [ Fa, Za, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ Fa, Za, 4 ], [ Fa, Da, 1 ], [ Fa, Ya, 1 ], [ Fa, Qa, 1 ], [ Fa, 64, Na, "keyframe" ], [ Fa, 64, Ca, "media", "supports", "container" ], [ Fa, 64, Oa ], [ Fa, uh, 13 ], [ 47, 42, 16 ], [ Fa, 59, ja ], [ Fa, ch, ja ], [ Fa, Ha, ja ], ...fh ], [ [ Fa, Xa, La ] ], [ [ Fa, Xa, La ] ], [ [ Fa, 40, Aa ], [ Fa, Xa, La ] ], [ [ Fa, 40, 8 ], [ Fa, Xa, La ] ], [ [ Fa, 40, Aa ], [ Fa, Xa, ja ] ], [ [ Fa, Xa, ja ] ], [ [ Fa, 93, La ], [ Fa, 39, 14 ], [ Fa, 34, 15 ] ], [ [ Fa, Ha, ja ], ...fh ], [ [ Fa, ch, ja ], ...fh ], [ [ Fa, ch, ja ], [ Wa, Da, 1 ], [ Fa, Za, xa, "global" ], [ Fa, uh, 13 ], ...fh ], [ [ Fa, uh, Aa ], [ Fa, 59, ja ], ...fh ], [ [ Fa, 59, ja ], [ Fa, uh, 9 ], ...fh ], [ [ Fa, ch, ja ], [ Fa, uh, 13 ], [ Fa, 40, 8 ], ...fh ], [ [ Fa, 39, ja ] ], [ [ Fa, 34, ja ] ], [ [ 42, 47, ja ] ] ])();

const hh = t => ({
    styleId: yh(t, t => t, !1)
});

const dh = /*#__PURE__*/ Is(hh);

const ph = t => ({
    scopeId: oi + yh(t, Sa, !0)
});

const $h = /*#__PURE__*/ Is(ph);

const yh = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = Xo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${or(t.st)}-${n}`)(t, i);
    const l = r.m;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.Qe(n(t, c), c, l, e));
    }
    r.$.Qe(n(t.resolved, c), c, l, e);
    return c;
};

const mh = (t, n) => {
    t.resolve();
    return Cs(t, n);
};

const wh = (t, n) => Uo(mh, t, n);

const vh = Is(wh);

const bh = t => {
    t.resolve();
    return js(t);
};

const _h = t => Uo(bh, t);

const gh = Is(_h);

const Eh = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = Xo();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !ed()) {
            e.h |= 32;
            Sh(e, i);
        }
        return;
    }
    let c;
    if (ed()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        yn(r.$, r.m, 1);
    }
    const l = new ku(c, o, r.m, t, null);
    s(l);
    Sh(l, i);
};

const Sh = (t, n) => {
    n === "intersection-observer" ? Dc("qvisible", kh(t)) : n === "document-ready" ? Xc("qinit", kh(t)) : n === "document-idle" && Xc("qidle", kh(t));
};

const kh = t => ea(null, "_task", An, null, [ t ]);

const Rh = Is(jc);

const Ph = /*#__PURE__*/ Is(Eu);

const Th = /*#__PURE__*/ Is(Eh);

const qh = (t, n) => {
    t.resolve();
    return Os(t, n);
};

const Ah = (t, n) => Uo(qh, t, n);

const Mh = Is(Ah);

const xh = () => {
    const t = _a({
        error: void 0
    });
    pf(mf, t);
    return t;
};

const Ih = async ({track: t}) => {
    const n = Yf[0];
    t(() => n.items);
    const e = qf();
    const s = e.m;
    const o = e.$;
    yn(o, s, 256);
    const r = Ne;
    r && await o.l;
};

const Nh = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Eu(/*#__PURE__*/ gc(Ih, "_eaT", [ t ]));
    return _o;
};

const Ch = /*#__PURE__*/ pa(
/*#__PURE__*/ gc(Nh, "_eaC"));

const Oh = (t, n, e) => Ge(t) ? t.getFn(n)(e) : t(e);

const jh = ({track: t}) => {
    const n = Yf[0];
    const e = qf();
    const s = e.m;
    const o = e.$;
    const r = Ne;
    return Yi(t(() => Oh(n.when$, qf(), void 0)), t => {
        const i = t ? n.then$ : n.else$;
        return Yi(i ? Oh(i, e, t) : null, t => {
            const n = i ? [ t ] : [];
            if (r) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            Ut(s, n);
            yn(o, s, 2);
        });
    });
};

const Lh = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    Eu(/*#__PURE__*/ gc(jh, "_shT", [ t ]));
    return _o;
};

const Fh = /*#__PURE__*/ pa(
/*#__PURE__*/ gc(Lh, "_shC"));

const Dh = /*#__PURE__*/ df("qk-reveal");

const Xh = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Ls(0)
});

const Wh = () => {
    const t = Yf[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!Ce) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return ld(t);
};

const Vh = ({cleanup: t}) => {
    const n = Yf[0];
    t(() => {
        if (!Ce) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Uh = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = Uo(Xh, t);
    pf(Dh, n);
    const e = !Ce;
    if (__EXPERIMENTAL__.suspense && e && hd()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                if (!hd()) {
                    return null;
                }
                const e = qf()?.$;
                let s = 0;
                if (e) {
                    s = (ud.get(e) || 0) + 1;
                    ud.set(e, s);
                }
                return new fd(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = ff(e);
            return e;
        })(n);
        /*#__PURE__*/
        return uo(pd, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    /*#__PURE__*/
    return uo(bo, null, null, null, 0, "u7_0");
};

const zh = /*#__PURE__*/ pa(
/*#__PURE__*/ gc(Uh, "_reC"));

const pd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ cd((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ uo(bo, null, null, null, 0, "u7_0"));
}) : null;

const Bh = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || e !== null && !e.value && s.reveal.collapsed ? "none" : "contents"
});

const $d = '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2===null||p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const Qh = (t, n, e) => ({
    display: n.value !== "content" && !t.showStale || e !== null && !e.value ? "none" : "contents"
});

const Hh = ({track: t, cleanup: n}) => {
    const e = Yf[0], s = Yf[1], o = Yf[2], r = Yf[3];
    const i = t(e.pending);
    const c = Ce;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.pending.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Jh = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = Vo("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return Uo(zo);
    })();
    const s = (t => {
        const n = $f(Dh, null);
        const e = Uo(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Eu(/*#__PURE__*/ gc(Vh, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = wh(
    /*#__PURE__*/ gc(Wh, "_reR", [ s ]));
    Eu(
    /*#__PURE__*/ gc(Hh, "_suT", [ e, t, n, s ]));
    const r = !Ce;
    const i = r && hd();
    const c = i ? (() => {
        if (!__EXPERIMENTAL__.suspense) {
            return 0;
        }
        const t = qf()?.$;
        if (t?.outOfOrderStreaming !== !0) {
            return 0;
        }
        return t?.nextOutOfOrderId?.() ?? 0;
    })() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && function f(t, n) {
        return t != null && t !== !1 && (n === null || n.showFallback);
    }(t.fallback, l);
    const a = u && wd(t.delay) ? {
        contentResolved: !1,
        delayTimer: null
    } : null;
    const h = i ? /*#__PURE__*/ Mc(Bh, [ t, n, o, s ], $d) : null;
    const d = /*#__PURE__*/ Mc(Qh, [ t, n, o ], '{display:(p1.value==="content"||p0.showStale)&&(p2===null||p2.value)?"contents":"none"}');
    const p = i ? /*#__PURE__*/ uo(yd, {
        boundary: a,
        delay: t.delay,
        fallbackStyle: h,
        showFallback: u,
        state: n
    }, null, zs(t, "fallback"), 1, null) : /*#__PURE__*/ uo("div", {
        style: Mc(Bh, [ t, n, o, s ], $d)
    }, null, zs(t, "fallback"), 1, null);
    return [ p, 
    /*#__PURE__*/ uo("div", null, i ? {
        [nd]: c + "",
        style: d
    } : {
        style: d
    }, 
    /*#__PURE__*/ uo(i ? md : bo, i ? {
        [ki]: e,
        boundary: a,
        boundaryId: c,
        contentStyle: d,
        reveal: l
    } : {
        [ki]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const Yh = /*#__PURE__*/ pa(
/*#__PURE__*/ gc(Jh, "_suC"));

const yd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ cd((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.delay;
    const i = n.varProps.fallbackStyle;
    const c = n.varProps.showFallback === !0;
    const l = n.varProps.state;
    c && !wd(r) ? l.value = "fallback" : o && c && wd(r) && s(() => function n(t, e, s, o) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.S(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, o);
    }(t, o, l, r));
    s(
    /*#__PURE__*/ uo("div", {
        style: i
    }, null, n.children, 1, null));
}) : null;

const md = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ cd(async (t, n, e) => {
    const s = n.varProps.boundaryId ?? t.nextOutOfOrderId();
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = t.segment(o, function u(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            /*#__PURE__*/
            return uo(bo, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = k(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        /*#__PURE__*/
        return uo(bo, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    (function f(t, n) {
        t.write(`<template ${fi}="${n}"></template>`);
    })(t, s);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(l.then(n => async function e(t, n, s, o, r, i, c) {
        (function l(t) {
            if (!t) {
                return;
            }
            t.contentResolved = !0;
            if (t.delayTimer) {
                clearTimeout(t.delayTimer);
                t.delayTimer = null;
            }
        })(c);
        i?.resolve();
        await t.S(async () => {
            t.addRoot(r);
            const e = await o.container.P(s, o);
            (function c(t, n, e, s) {
                t.write(`<template ${fi}="${n}"${s?.attrs ?? ""}>`);
                t.write(e);
                t.write("</template>");
            })(t, n, e.html, i);
            t.emitOutOfOrderSegmentScripts(e.scripts);
            t.emitInlineScript(`qO(${n})`);
            await t.streamHandler.flush();
        });
    }(t, s, o, n, i, c, r)));
}) : null;

function wd(t) {
    return typeof t === "number" && Number.isFinite(t) && t > 0;
}

const Gh = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = Kh.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return uo("script", null, o, null, 0, "prefetch-service-worker");
};

const Kh = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const Zh = () => null;

globalThis.__qwik && Je(30, [ globalThis.__qwik, Dr ]);

globalThis.__qwik = Dr;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { ca as $, Ch as Each, wo as Fragment, af as NoSerializeSymbol, Zh as PrefetchGraph, Gh as PrefetchServiceWorker, vo as RenderOnce, Lc as Resource, zh as Reveal, Eo as SSRComment, go as SSRRaw, ko as SSRStream, So as SSRStreamBlock, hf as SerializerSymbol, Fh as Show, _o as SkipRender, bo as Slot, Yh as Suspense, ms as _CONST_PROPS, Rf as _DomContainer, Wr as _EFFECT_BACK_REF, Ci as _ELEMENT_SEQ, Es as _EMPTY_ARRAY, Ss as _EMPTY_OBJ, _s as _IMMUTABLE, xc as _SharedContainer, Js as _SubscriptionData, Gu as _SubscriptionPatch, ku as _Task, gs as _UNINITIALIZED, ws as _VAR_PROPS, Yn as _addProjection, Yf as _captures, b as _chk, fe as _createDeserializeContainer, ea as _createQRL, xn as _createStore, Gi as _delay, ue as _deserialize, $c as _dumpState, Nh as _eaC, Ih as _eaT, pn as _executeSsrChores, Mc as _fnSignal, Ac as _getAsyncLocalStorage, Ms as _getConstProps, Ff as _getContextContainer, Lf as _getContextEvent, jf as _getContextHostElement, ge as _getDomContainer, Se as _getQContainerElement, m as _getSubscriber, As as _getVarProps, Wu as _hasStoreEffects, zc as _hmr, ys as _injectAsyncSignalValue, Te as _invoke, Ks as _isJSXNode, Uu as _isStore, Vn as _isStringifiable, Ru as _isTask, Df as _jsxBranch, fo as _jsxC, ho as _jsxQ, ao as _jsxS, uo as _jsxSorted, co as _jsxSplit, De as _mapApp_findIndx, We as _mapArray_get, Xe as _mapArray_set, Ou as _markSignalAsExternallyOwned, Me as _newInvokeContext, Ec as _noopQrl, Sc as _noopQrlDEV, Dn as _preprocessState, da as _qrlSync, On as _qrlToString, kc as _qrlWithChunk, Rc as _qrlWithChunkDEV, Uh as _reC, Wh as _reR, Vh as _reT, qc as _regSymbol, Zn as _removeProjection, _ as _res, yf as _resolveContextWithoutSequentialScope, Ao as _restProps, n as _retryOnPromise, Oc as _rsc, I as _run, le as _serialize, Qn as _setEvent, Gn as _setProjectionTarget, Lh as _shC, jh as _shT, Jh as _suC, Hh as _suT, An as _task, Kn as _updateProjectionProps, Jn as _useHmr, v as _val, sf as _verifySerializable, Sl as _vnode_ensureElementInflated, du as _vnode_getAttrKeys, Bl as _vnode_getElementName, Jl as _vnode_getFirstChild, bl as _vnode_getProp, Ml as _vnode_getVNodeForChildNode, Xl as _vnode_insertBefore, pl as _vnode_isElementVNode, yl as _vnode_isMaterialized, ml as _vnode_isTextVNode, wl as _vnode_isVirtualVNode, hl as _vnode_newVirtual, Ul as _vnode_remove, _l as _vnode_setProp, En as _vnode_toString, Xf as _waitUntilRendered, zn as _walkJSX, zs as _wrapProp, Qs as _wrapSignal, ma as component$, pa as componentQrl, Ds as createAsync$, Os as createAsyncQrl, Fs as createComputed$, Cs as createComputedQrl, df as createContextId, g as createElement, Xs as createSerializer$, js as createSerializerQrl, Ls as createSignal, wa as event$, aa as eventQrl, Xu as forceStoreEffects, va as getClientManifest, ge as getDomContainer, Re as getLocale, yr as getPlatform, g as h, Is as implicit$FirstArg, gc as inlinedQrl, Tc as inlinedQrlDEV, Oe as isDev, Tu as isSignal, $o as jsx, yo as jsxDEV, mo as jsxs, ff as noSerialize, _c as qrl, Pc as qrlDEV, ba as render, $r as setPlatform, ha as sync$, If as untrack, Vu as unwrapStore, Mh as useAsync$, Ah as useAsyncQrl, vh as useComputed$, wh as useComputedQrl, Uo as useConstant, $f as useContext, pf as useContextProvider, xh as useErrorBoundary, ga as useId, Cc as useLexicalScope, Dc as useOn, Xc as useOnDocument, Wc as useOnWindow, Rh as useResource$, jc as useResourceQrl, gh as useSerializer$, _h as useSerializerQrl, xe as useServerData, Vo as useSignal, _a as useStore, dh as useStyles$, hh as useStylesQrl, $h as useStylesScoped$, ph as useStylesScopedQrl, Ph as useTask$, Eu as useTaskQrl, Th as useVisibleTask$, Eh as useVisibleTaskQrl, Dr as version, Pe as withLocale };
